<template>
    <!--srcviewscompanylistriskvuehtmlStart-->
    <div>
        <CompanyQuestion ref="CompanyQuestion" v-show="CompanyQuestionShow" :CompanyQuestionShow="CompanyQuestionShow"
            @getPantentList="getPantentList($event)"></CompanyQuestion>
        <div v-show="!CompanyQuestionShow" id="defaultId1" class="uedbd2"
            style="display: flex; height: 100%; background: #f5f5f5">

         <div style="overflow: hidden; transition: 0.2s;" :class="$store.state.app.isMenu ? '' : 'hidemenu'" v-loading="RiskLoding">
            <div class="left_menu-headbox ">
            <h2 class="left_menu_title">Top 20 Genetic research companies</h2>
            <ul class="flex_center_bettwen flilterClass margin-left20 margin-bottom20 margin-right20">
                            <li v-for="(item, index) in FilterList" :class="index == FilterIndex ? 'yellow' : 'yellownone'"
                                :key="index" @click=FilterChange(index)>{{ item.name }}</li>
                        </ul>
                    </div>
            <div style="height: 79%; overflow-y: auto;overflow-x: hidden;padding-bottom: 11%;">
                <div :class="!this.Compare ? '' : 'vague'">
                   
                    <!-- v-if="$route.name == 'riskNoParams'" -->
                    <div class="left_menu" >
                        <!-- <h2 class="left_menu_title">Top 100 Genetic research companies</h2> -->
                   
                        <div v-if="FilterIndex == 0" >
                            <div v-for="(ite, ind) in ComanyFilterList" :key="ind" class="FilterQuestion">
                                <div class="left_menu_question" v-if="ite.leadsOptions.length > 0">
                                    <p>{{ ite.leadsQuestions.questionContent }}</p>
                                    <div v-if="ite.leadsQuestions.type == 10">
                                        <div class="coll_child">
                                            <el-checkbox-group fill="#8E86DD" v-model="ite.selectedCodes"
                                                @change="menuCheck()">
                                                <el-checkbox v-for="(child, i) in ite.leadsOptions"
                                                    :key="child.optionsCode" :label="child.optionsCode">
                                                    <el-tooltip :disabled="child?.optionsContent?.length < 30"
                                                        class="line_1 coll_child_name " effect="dark"
                                                        :content="child.optionsContent" placement="right">
                                                        <!-- @mouseover="onMouseOver(child.optionsContent, i)" -->
                                                        <div class="line_1 coll_child_name">
                                                            <span style="font-style: none" ref="str">{{
                                                                child.optionsContent
                                                                }}</span>
                                                        </div>
                                                    </el-tooltip>

                                                </el-checkbox>
                                            </el-checkbox-group>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div v-if="FilterIndex == 1">
                            <div v-for="(item, index) in CompanyQuestionList" :key="index">
                                <div class="left_menu_question" v-if="item.selectedCodes != null">
                                    <p>{{ item.leadsQuestions.questionContent }}</p>
                                    <div v-if="item.leadsQuestions.type == 1">
                                        <el-cascader v-model="item.selectedCodes.id" style="width: 100%"
                                            :disabled="true" filterable :popper-append-to-body="false"
                                            :props="cascaderProps" :options="item.leadsOptions"
                                            placeholder="Please select Please choose your role" ref="cascader">
                                        </el-cascader>
                                    </div>
                                    <div v-if="item.leadsQuestions.type == 2">
                                        <el-select filterable style="width: 100%" :popper-append-to-body="false"
                                            :disabled="true" value-key="optionsCode" v-model="item.selectedCodes"
                                            :placeholder="item.leadsQuestions.questionContent">
                                            <el-option v-for="ite in item.leadsOptions" :key="ite.optionsCode"
                                                :label="ite.optionsContent" :value="ite">
                                            </el-option>
                                        </el-select>

                                        <!-- {{
    item.selectedOptions
}} -->
                                    </div>
                                    <div v-if="
                                        item.leadsQuestions.type == 3 &&
                                        item.selectedCodes.length > 0
                                    ">
                                        <el-select style="width: 100%" clearable value-key="optionsCode"
                                            :multiple="true" :disabled="true" :popper-append-to-body="false"
                                            v-model="item.selectedCodes"
                                            :placeholder="item.leadsQuestions.questionContent">
                                            <el-option v-for="ite in item.leadsOptions" :key="ite.optionsCode"
                                                :label="ite.optionsContent" :value="ite">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div v-if="item.leadsQuestions.type == 5">
                                        <div style="display: flex;margin-bottom: 10px;">
                                            <el-radio v-model="item.selectedCodes" :disabled="true"
                                                :label="item.selectedCodes.length > 0 ? item.selectedCodes : 'Yes'"
                                                border>Yes</el-radio>
                                            <el-radio v-model="item.selectedCodes" :disabled="true"
                                                :label="item.selectedCodes.length > 0 ? 'No' : item.selectedCodes"
                                                border>No</el-radio>
                                        </div>
                                        <el-input id="ceb3e3" v-model="item.selectedCodes" :disabled="true"
                                            :placeholder="item.leadsQuestions.questionContent">
                                        </el-input>
                                    </div>
                                    <div v-if="item.leadsQuestions.type == 8">
                                        <el-input id="ceb3e3" v-model="item.selectedCodes.optionsContent"
                                            :disabled="true" :placeholder="item.leadsQuestions.questionContent">
                                        </el-input>

                                        <!-- <el-select filterable style="width: 100%" :disabled="true"
                                        :popper-append-to-body="false" value-key="optionsCode"
                                        v-model="item.selectedCodes" remote
                                        :placeholder="item.leadsQuestions.questionContent">
                                        <el-option v-for="ite in item.leadsOptions" :key="ite.optionsCode"
                                            :label="ite.optionsContent" :value="ite">
                                        </el-option>
                                    </el-select> -->

                                        <!-- {{
                                                        item.selectedOptions
                                                    }} -->
                                    </div>
                                    <div v-if="item.leadsQuestions.type == 7">
                                        <el-input id="ceb3e3" v-model="item.selectedCodes" :disabled="true"
                                            :placeholder="item.leadsQuestions.questionContent">
                                        </el-input>


                                    </div>
                                    <div v-if="item.leadsQuestions.type == 9">
                                        <el-select filterable clearable style="width: 100%;"
                                            :popper-append-to-body="false" ref="upSelectduoxuanSearch"
                                            value-key="aaa_id" v-model="item.selectedCodes" remote :multiple="true"
                                            :disabled="true" :placeholder="item.leadsQuestions.questionContent">
                                            <el-option v-for="(ite) in item.leadsOptions" :key="ite.aaa_id"
                                                :label="ite.optionsContent" :value="ite">
                                                <div class="flex_center_start_box Search_Company"> <img
                                                        class="Country_img" :src="ite.flag" /><span
                                                        class="Country_name">{{ ite.optionsContent }}</span></div>
                                            </el-option>
                                        </el-select>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <p class="left_menu_bottom">
                            <!-- Does your company have any overseas companies? -->
                        </p>
                        <div class="AnswerbutoonBox">     <p class="Answerbutoon" @click="SaveMyAnswer()">Save My Answer</p></div>
                   
                    </div>
                </div>
            </div>
         </div>


            <div id="cc5f49" :class="$store.state.app.isMenu
                ? 'scrollbar udb507'
                : ' scrollbar udb507 udb507two'
                ">
                <div style="height: 100%;">
                    <div class="list-label" v-show="!Compare" style="height: 100%;">
                        <div id="c6d65e" class="ub7918 Alchecked flex_between_box"
                            style="padding-left: 20px; align-items: center">
                            <div>
                                <el-checkbox v-if="isOpenSlct" style="margin-right: 20px" id="c0b733" v-model="checked"
                                    label @change="changeSlctAll">All</el-checkbox>
                                Found over {{ CompanyList?.slice(0,20).length }}
                                <el-button v-if="isOpenSlct" class="margin-left20" style="height: 40px !important;min-height: 40px !important;" :class="$store.state.app.collectList.length == 0||$store.state.app.changeList.length==0
                                    ? ' btn_export leadsDialogD8850'
                                    : 'btn_exportCollect'
                                    " :disabled="$store.state.app.collectList.length == 0||$store.state.app.changeList.length==0"
                                    @click="CollectCheckBook">Confirm</el-button>
                            </div>
                          <div  class="flex_center">
                            <div  @click="getleadsPostFilterchangeSearch" v-if="CompanyListRandom.length>0&&(!(['MF1003','TC1003','SC1003'].includes(leadsListModuleCode)))" >
                                <span  class="huanyipi flex_center_bettwen"><svg t="1741324292794"
                                        class="icon" viewBox="0 0 1024 1024" version="1.1"
                                        xmlns="http://www.w3.org/2000/svg" p-id="6133" width="1.7142857142857142rem"
                                        height="1.7142857142857142rem">
                                        <path
                                            d="M918.565926 534.281481c-11.757037 0-21.333333-9.576296-21.333333-21.333333 0-211.721481-172.278519-384-384-384-146.868148 0-278.660741 81.73037-344.082963 213.333333-5.214815 10.524444-18.014815 14.885926-28.634074 9.576297-10.524444-5.214815-14.885926-18.014815-9.576297-28.634074C165.736296 253.155556 219.211852 193.991111 285.392593 152.082963 353.46963 109.037037 432.260741 86.281481 513.232593 86.281481c57.552593 0 113.493333 11.282963 166.115555 33.564445 50.820741 21.522963 96.426667 52.242963 135.585185 91.401481 39.158519 39.158519 69.973333 84.764444 91.401482 135.585186 22.281481 52.622222 33.564444 108.468148 33.564444 166.115555 0 11.757037-9.576296 21.333333-21.333333 21.333333z"
                                            p-id="6134" fill="#685ED1"></path>
                                        <path
                                            d="M918.660741 534.281481c-5.499259 0-10.903704-2.085926-15.075556-6.257777L797.392593 421.925926c-8.343704-8.343704-8.343704-21.807407 0-30.151111s21.807407-8.343704 30.151111 0l106.192592 106.192592c8.343704 8.343704 8.343704 21.807407 0 30.151112-4.171852 4.077037-9.671111 6.162963-15.075555 6.162962z"
                                            p-id="6135" fill="#685ED1"></path>
                                        <path
                                            d="M513.422222 939.614815c-57.552593 0-113.493333-11.282963-166.115555-33.564445-50.820741-21.522963-96.426667-52.242963-135.585186-91.401481-39.158519-39.158519-69.973333-84.764444-91.401481-135.585185-22.281481-52.622222-33.564444-108.562963-33.564444-166.115556 0-11.757037 9.576296-21.333333 21.333333-21.333333s21.333333 9.576296 21.333333 21.333333c0 211.721481 172.278519 384 384 384 146.868148 0 278.660741-81.73037 344.082963-213.333333 5.214815-10.524444 18.014815-14.885926 28.634074-9.576296 10.524444 5.214815 14.885926 18.014815 9.576297 28.634074C860.918519 772.740741 807.442963 831.905185 741.262222 873.813333 673.09037 916.859259 594.299259 939.614815 513.422222 939.614815z"
                                            p-id="6136" fill="#685ED1"></path>
                                        <path
                                            d="M214.091852 640.474074c-5.499259 0-10.903704-2.085926-15.075556-6.257778l-106.192592-106.192592c-8.343704-8.343704-8.343704-21.807407 0-30.151111s21.807407-8.343704 30.151111 0l106.192592 106.192592c8.343704 8.343704 8.343704 21.807407 0 30.151111-4.171852 4.171852-9.576296 6.257778-15.075555 6.257778z"
                                            p-id="6137" fill="#685ED1"></path>
                                    </svg>
                                      <span style="margin-left: 0.3rem;"  @click="getSearchListTypecode">Change seach</span>
                    
                                </span>
                             
                            </div>
                            <div @click="ChangeIt">
                                <span v-if="riskTotal>20"  class="huanyipi flex_center_bettwen"><svg t="1741324292794"
                                        class="icon" viewBox="0 0 1024 1024" version="1.1"
                                        xmlns="http://www.w3.org/2000/svg" p-id="6133" width="1.7142857142857142rem"
                                        height="1.7142857142857142rem">
                                        <path
                                            d="M918.565926 534.281481c-11.757037 0-21.333333-9.576296-21.333333-21.333333 0-211.721481-172.278519-384-384-384-146.868148 0-278.660741 81.73037-344.082963 213.333333-5.214815 10.524444-18.014815 14.885926-28.634074 9.576297-10.524444-5.214815-14.885926-18.014815-9.576297-28.634074C165.736296 253.155556 219.211852 193.991111 285.392593 152.082963 353.46963 109.037037 432.260741 86.281481 513.232593 86.281481c57.552593 0 113.493333 11.282963 166.115555 33.564445 50.820741 21.522963 96.426667 52.242963 135.585185 91.401481 39.158519 39.158519 69.973333 84.764444 91.401482 135.585186 22.281481 52.622222 33.564444 108.468148 33.564444 166.115555 0 11.757037-9.576296 21.333333-21.333333 21.333333z"
                                            p-id="6134" fill="#685ED1"></path>
                                        <path
                                            d="M918.660741 534.281481c-5.499259 0-10.903704-2.085926-15.075556-6.257777L797.392593 421.925926c-8.343704-8.343704-8.343704-21.807407 0-30.151111s21.807407-8.343704 30.151111 0l106.192592 106.192592c8.343704 8.343704 8.343704 21.807407 0 30.151112-4.171852 4.077037-9.671111 6.162963-15.075555 6.162962z"
                                            p-id="6135" fill="#685ED1"></path>
                                        <path
                                            d="M513.422222 939.614815c-57.552593 0-113.493333-11.282963-166.115555-33.564445-50.820741-21.522963-96.426667-52.242963-135.585186-91.401481-39.158519-39.158519-69.973333-84.764444-91.401481-135.585185-22.281481-52.622222-33.564444-108.562963-33.564444-166.115556 0-11.757037 9.576296-21.333333 21.333333-21.333333s21.333333 9.576296 21.333333 21.333333c0 211.721481 172.278519 384 384 384 146.868148 0 278.660741-81.73037 344.082963-213.333333 5.214815-10.524444 18.014815-14.885926 28.634074-9.576296 10.524444 5.214815 14.885926 18.014815 9.576297 28.634074C860.918519 772.740741 807.442963 831.905185 741.262222 873.813333 673.09037 916.859259 594.299259 939.614815 513.422222 939.614815z"
                                            p-id="6136" fill="#685ED1"></path>
                                        <path
                                            d="M214.091852 640.474074c-5.499259 0-10.903704-2.085926-15.075556-6.257778l-106.192592-106.192592c-8.343704-8.343704-8.343704-21.807407 0-30.151111s21.807407-8.343704 30.151111 0l106.192592 106.192592c8.343704 8.343704 8.343704 21.807407 0 30.151111-4.171852 4.171852-9.576296 6.257778-15.075555 6.257778z"
                                            p-id="6137" fill="#685ED1"></path>
                                    </svg>
                                    <span style="margin-left: 0.3rem;" >Refresh for more</span>
                                </span>
                             
                            </div>
                          </div>
                        </div>
                        <div class="flex_center_between_box" style="width: 100%;height: 98%;" v-loading="RiskLoding">
                            <div class="risk-center-list">
                                <div>
                                    <ul>
                                        <draggable filter=".forbid" v-model="CompanyList" :disabled="disabled"
                                            animation="300" :move="onMove">
                                            <transition-group>
                                                <li v-for="(item, index) in CompanyList?.slice(0,20)" :key="index" :class="item.isDing
                                                    ? 'conpany-center-list forbid item'
                                                    : 'conpany-center-list item'
                                                    ">
                                                    <div class="flex_between_box">
                                                        <div class="conpany-center-list-left">
                                                            <el-checkbox v-if="isOpenSlct" id="cee084"
                                                                style="margin-right: 10px;margin-top: 0.3rem;"
                                                                v-model="item.isChecked" label
                                                                @change="changeItemChecked">
                                                            </el-checkbox>
                                                            <span
                                                                :class="item.isDing ? 'indexPositon' : 'indexPositonactive'">{{
                                                                    index + 1 }}</span>
                                                            <div>
                                                                <p style="min-height: 2.142857142857143rem">
                                                                    <span @click="setNews(item, 'prife')" style="font-family: 'DMSans Bold';cursor: pointer;" :class="{
                                                                        overexperise: NationalIndustryShow,
                                                                    }">{{ item.company_name_en }}</span>
                                                                      <!-- <el-popover  placement="top" trigger="hover"  popper-class="Risk-list-popover"
                                                                    content="Verified">
                                                                    <span slot="reference"  class="margin20">
                                                                        
                                                                        <svg t="1733197205750"
                                                                            class="icon" viewBox="0 0 1024 1024"
                                                                            version="1.1"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            p-id="6215" width="1.7142857142857142rem"
                                                                            height="1.7142857142857142rem">
                                                                            <path
                                                                                d="M445.7472 959.0784a66.88768 66.88768 0 0 1-99.90144-26.76736 113.74592 113.74592 0 0 0-114.76992-66.2528 66.88768 66.88768 0 0 1-73.1136-73.13408 113.74592 113.74592 0 0 0-66.27328-114.76992 66.88768 66.88768 0 0 1-26.76736-99.90144 113.74592 113.74592 0 0 0 0-132.5056 66.88768 66.88768 0 0 1 26.76736-99.90144 113.74592 113.74592 0 0 0 66.2528-114.76992 66.88768 66.88768 0 0 1 73.13408-73.1136 113.74592 113.74592 0 0 0 114.76992-66.27328 66.88768 66.88768 0 0 1 99.90144-26.76736 113.74592 113.74592 0 0 0 132.5056 0 66.88768 66.88768 0 0 1 99.90144 26.76736 113.74592 113.74592 0 0 0 114.76992 66.2528 66.88768 66.88768 0 0 1 73.1136 73.13408 113.74592 113.74592 0 0 0 66.27328 114.76992 66.88768 66.88768 0 0 1 26.76736 99.90144 113.74592 113.74592 0 0 0 0 132.5056 66.88768 66.88768 0 0 1-26.76736 99.90144 113.74592 113.74592 0 0 0-66.2528 114.76992 66.88768 66.88768 0 0 1-73.13408 73.1136 113.74592 113.74592 0 0 0-114.76992 66.27328 66.88768 66.88768 0 0 1-99.90144 26.76736 113.74592 113.74592 0 0 0-132.5056 0z"
                                                                                fill="#55B419" p-id="6216"
                                                                                data-spm-anchor-id="a313x.manage_type_myprojects.0.i4.36203a81GdIWQo"
                                                                                class="selected"></path>
                                                                            <path
                                                                                d="M416.58368 368.64v12.75904c-3.3792 0-6.63552 0.8192-9.78944 2.47808-3.13344 1.65888-4.7104 4.85376-4.7104 9.58464 0 5.20192 2.048 11.81696 6.16448 19.8656l6.79936 13.45536 8.06912 16.30208 92.8768 195.01056 90.68544-192.16384c4.64896-9.8304 9.05216-18.8416 13.23008-27.01312l3.09248-5.95968c5.07904-9.68704 7.61856-16.42496 7.61856-20.21376 0-6.9632-5.75488-10.73152-17.3056-11.264l-3.01056-0.08192V368.64H737.28v12.75904c-9.66656 0-16.6912 3.44064-21.03296 10.28096a172.032 172.032 0 0 0-8.13056 13.96736l-133.67296 287.45728A40.96 40.96 0 0 1 537.31328 716.8h-46.42816a40.96 40.96 0 0 1-37.0688-23.53152l-138.07616-293.43744a23.77728 23.77728 0 0 0-10.15808-11.34592 85.66784 85.66784 0 0 0-14.90944-5.89824L286.72 381.39904V368.64h129.86368z"
                                                                                fill="#FFFFFF" p-id="6217"
                                                                                data-spm-anchor-id="a313x.manage_type_myprojects.0.i5.36203a81GdIWQo"
                                                                                class=""></path>
                                                                        </svg>
                                                                    </span>
                                                                        </el-popover> -->
                                                                    <span class="margin20">
                                                                        <svg t="1728813835525" class="icon"
                                                                            viewBox="0 0 1075 1024" version="1.1"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            p-id="12745" width="1.8571428571428572rem"
                                                                            height="1.7142857142857142rem">
                                                                            <path
                                                                                d="M273.757233 1023.872016a111.269069 111.269069 0 0 1-65.092533-21.142915 108.632604 108.632604 0 0 1-44.000812-107.378363l36.091416-208.459925c2.815642-16.074759-2.559675-32.379888-14.282986-43.591264l-0.102387-0.127984-152.863786-147.718839a108.58141 108.58141 0 0 1-28.054037-112.44652 109.835651 109.835651 0 0 1 89.358251-74.768104l211.249971-30.306551A49.836871 49.836871 0 0 0 343.610761 250.85019l94.477602-189.646315A110.168409 110.168409 0 0 1 537.454943 0.002048c42.413813 0 80.578567 23.421026 99.340984 61.227424l94.452005 189.646315c7.218283 14.48776 21.245302 24.624073 37.576027 27.055764l211.249972 30.434535a110.040425 110.040425 0 0 1 89.486235 74.742507 108.325443 108.325443 0 0 1-28.054037 112.472116l-152.863787 147.590856a49.504113 49.504113 0 0 0-14.385373 43.719248l36.091417 208.357538a108.607007 108.607007 0 0 1-44.128796 107.378363 110.731537 110.731537 0 0 1-116.541999 8.318944l-188.955203-98.445098a49.862467 49.862467 0 0 0-46.330116 0l-188.929606 98.445098a110.321989 110.321989 0 0 1-51.705433 12.926358z"
                                                                                :fill="item.isFavorite
                                                                                    ? '#F56B6B'
                                                                                    : '#CCCCCC'
                                                                                    " p-id="12746"></path>
                                                                        </svg></span>
                                                                    <span class="margin20">
                                                                        <svg t="1733198040076"
                                                                            @click="getCompanyDetailList(item, index)"
                                                                            :class="{ rotate: item.isRotated }"
                                                                            class="icon icontransform"
                                                                            viewBox="0 0 1024 1024" version="1.1"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            p-id="12095" width="2.142857142857143rem"
                                                                            height="2.142857142857143rem">
                                                                            <path d="M0 0h1024v1024H0z" fill="#8E86DD"
                                                                                fill-opacity=".01" p-id="12096"></path>
                                                                            <path
                                                                                d="M768 362.666667H256c-38.016 0-57.045333 45.952-30.165333 72.832l256 256a42.666667 42.666667 0 0 0 60.330666 0l256-256C825.045333 408.618667 806.016 362.666667 768 362.666667z"
                                                                                fill="#8E86DD" p-id="12097"></path>
                                                                        </svg></span>
                                                                </p>

                                                                <p class="list-text-color" style="color:#29445D !important;">
                                                                    <img :src="item.flag" />{{
                                                                        item.company_country
                                                                    }}
                                                                </p>
                                                                <p v-if="item.company_country=='CN'" class="list-text-color">
                                                                    Company Number:<span>{{
                                                                        item.usc_code
                                                                        }}</span>
                                                                </p>
                                                                <p v-else class="list-text-color">
                                                                    Company Number:<span>{{
                                                                        (item.reg_number==''||item.reg_number==null)?item.usc_code:item.reg_number
                                                                        }}</span>
                                                                </p>
                                                                <p class="list-text-color">
                                                                    Address:<span :class="{
                                                                        overexperise: NationalIndustryShow,
                                                                    }">
                                                                        {{ item.street_en }} <span style="margin-left: 0px;" v-show="item.street_en && item.street_en != ' ' && item.street_en != '' && item.city_en != '' && item.city_en != ' ' && item.city_en">,</span>
                                                                        {{ item.city_en }} 
                                                    <span  style="margin-left: 0px;" v-show="item.province_en && item.province_en != ' ' && item.province_en != '' && item.city_en != '' && item.city_en != ' ' && item.city_en">, </span>
                                                    {{ item.province_en }} 
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div class="conpany-center-list-right">
                                                            <p>
                                                                <el-popover  placement="top" trigger="hover"  popper-class="Risk-list-popover"
                                                                    content="Lock in List">
                                                                    <span slot="reference">
                                                                          <!-- -->
                                                                        <svg  @click="CansoleClick(item, index)" t="1733203627607" v-if="item.isDing" style="margin-top: 2px;"
                                                                          
                                                                            class="icon" viewBox="0 0 1024 1024"
                                                                            version="1.1"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            p-id="7557" width="1.7857142857142858rem"
                                                                            height="1.7857142857142858rem">
                                                                            <path
                                                                                d="M990.73312 306.653c-2.624-2.624-254.57-254.32-279.19-278.44-0.875-0.875-1.625-1.625-2.625-2.375-45.74-37.242-111.6-33.868-153.217 7.874-35.242 35.117-33.243 82.232-31.993 112.85 0.125 7.874 0.375 15.997 0.375 23.495 0 32.618-30.744 79.858-78.233 120.35-49.615 42.366-106.728 68.235-139.096 62.986-7.623-1.25-14.622-1.874-20.87-2.374-3-0.25-5.624-0.5-8.248-0.75-152.718-37.867-221.453 62.362-229.451 74.984-11.623 20.246-8.499 45.74 7.873 61.987l166.964 166.964-212.97 288.313c-15.122 20.246-12.997 48.115 5.124 66.361 9.998 9.998 22.995 15.122 35.992 15.122 10.498 0 20.996-3.25 29.869-9.998L372.35012 803.547l164.964 164.965c16.622 16.621 42.366 19.746 62.987 7.248 11.498-7.248 111.476-75.484 74.61-225.077-0.376-2.5-2.5-20.62-3.625-30.868-2.625-31.993 28.619-103.353 79.358-158.591 35.992-39.117 72.86-60.737 103.728-60.737 7.498 0 15.621 0.125 22.995 0.375 31.243 1.374 78.483 3.374 113.6-31.743 21.62-21.62 33.618-50.365 33.493-81.108-0.109-30.744-11.997-59.612-33.727-81.358z"
                                                                                fill="#685ED1" p-id="7558"></path>
                                                                        </svg>
                                                                        <svg v-else t="1733211664573" style="margin-top: 2px;" class="icon"
                                                                            @click="DingClick(item, index)"
                                                                            viewBox="0 0 1026 1024" version="1.1"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            p-id="7806" width="1.7857142857142858rem"
                                                                            height="1.7857142857142858rem">
                                                                            <path
                                                                                d="M51.197143 1024c-13.021992 0-26.0184-5.091113-36.021541-15.094254-18.113104-18.164271-20.262117-46.050265-5.091113-66.337966l213.059228-288.325828-166.983379-166.983379C39.863661 470.961896 36.640143 445.48075 48.30621 425.2698c7.982046-12.612656 76.699275-112.82315 229.483822-75.010766 2.532765 0.307002 5.270197 0.537253 8.212297 0.793088 6.267953 0.537253 13.277827 1.17684 20.87612 2.404847 32.33752 5.244614 89.516599-20.722619 139.148552-63.037697 47.559691-40.49865 78.285451-87.751339 78.285451-120.344693 0-7.57271-0.179084-15.631507-0.358169-23.536802-1.279174-30.623426-3.223519-77.697031 31.979351-112.874317 41.649907-41.701074 107.552953-45.05251 153.270633-7.854129 0.921005 0.741921 1.76526 1.535009 2.583932 2.379264l-0.025583 0c24.585725 24.048472 276.608594 275.815506 279.243692 278.476188 21.694792 21.694792 33.642277 50.527374 33.693444 81.176384 0.025583 30.674593-11.896319 59.456009-33.539943 81.099634-35.023785 35.049369-82.353225 33.053857-113.565071 31.723516-7.393626-0.153501-15.478006-0.332585-23.025133-0.332585-30.828094 0-67.69389 21.592458-103.715431 60.760767-50.808793 55.260318-82.09739 126.63823-79.411124 158.617581 1.125673 10.258976 3.223519 28.37208 3.607271 30.930428 36.891379 149.612195-63.114447 217.843339-74.627013 225.109047-20.697036 12.484739-46.357267 9.389137-63.012113-7.240125l-178.393611-178.393611c-10.003141-10.003141-10.003141-26.171901 0-36.175042s26.171901-10.003141 36.175042 0l178.393611 178.393611c7.854129-5.091113 80.101878-54.646315 51.320462-171.76749-0.51167-2.35368-3.044434-23.562386-4.374775-35.970374-4.298025-51.115795 35.586622-136.027367 92.688951-198.118475 32.439854-35.254036 83.27423-77.287695 141.348731-77.287695 7.905296 0 16.399011 0.179084 24.662475 0.358169 32.41427 1.355924 58.048918 0.972172 75.77827-16.782763 11.973069-11.973069 18.548024-27.885994 18.548024-44.847842-0.025583-17.013015-6.677288-33.00269-18.701524-45.05251C952.221752 340.23031 683.851039 72.243349 675.945743 64.645055c-24.278723-19.724864-60.7096-17.882853-83.785899 5.21903-17.908437 17.908437-18.317772 43.491917-17.013015 75.087516 0.204668 8.800717 0.383752 17.243266 0.383752 25.148562 0 48.378362-35.995957 107.936705-96.270638 159.282751-49.478452 42.135993-122.979792 83.811483-180.491457 74.60143-6.293536-1.023339-12.049819-1.509425-17.192099-1.944345-3.325852-0.281418-6.421454-0.562837-9.312387-0.921005-2.456014-0.07675-4.860861-0.537253-7.188958-1.304758-117.760762-29.037251-167.597382 43.44075-172.893163 51.806549l182.742803 182.026466c8.954218 8.954218 10.028724 23.101883 2.481598 33.309692L51.17156 973.114457l238.617125-174.530506c11.435816-8.365798 27.425491-5.80745 35.740123 5.602782s5.80745 27.399908-5.602782 35.714539l-238.821793 174.12117C72.150014 1020.699731 61.68637 1024 51.197143 1024z"
                                                                                fill="#8497AB" p-id="7807"></path>
                                                                        </svg>
                                                                    </span>
                                                                </el-popover>
                                                                <span class="margin20"><svg t="1733202852628"
                                                                        @click="DelClick(item, index)" class="icon"
                                                                        viewBox="0 0 1024 1024" version="1.1"
                                                                        xmlns="http://www.w3.org/2000/svg" p-id="6455"
                                                                        width="2.357142857142857rem"
                                                                        height="2.357142857142857rem">
                                                                        <path
                                                                            d="M386.990351 752.645802L386.990351 359.958188c0-9.866718-8.003606-17.84953-17.851285-17.84953-9.849726 0-17.850261 7.982812-17.850261 17.84953l0 392.687614c0 9.850345 8.000536 17.851577 17.850261 17.851577C378.986745 770.497379 386.990351 762.496148 386.990351 752.645802zM529.793466 752.645802L529.793466 359.958188c0-9.866718-8.003606-17.84953-17.853331-17.84953-9.846656 0-17.848215 7.982812-17.848215 17.84953l0 392.687614c0 9.850345 8.001559 17.851577 17.848215 17.851577C521.788837 770.497379 529.793466 762.496148 529.793466 752.645802zM815.393554 324.259128c-9.845632 0-17.846168 7.983835-17.846168 17.84953l0 481.935264c0 19.697621-15.987768 35.700083-35.702569 35.700083L262.038521 859.744006c-19.715825 0-35.700523-16.002462-35.700523-35.700083L226.337999 342.109682c0-9.866718-8.001559-17.84953-17.850261-17.84953-8.3014 0-15.271424 5.681396-17.26286 13.373589-0.194436-0.107447-0.396036-0.204661-0.588425-0.316202l0 486.72843c0 39.429011 31.953022 71.39812 71.401046 71.39812l499.806295 0c39.430627 0 71.401046-31.969109 71.401046-71.39812L833.244839 342.109682C833.245862 332.242963 825.244303 324.259128 815.393554 324.259128zM869.04872 199.312418L663.473431 199.312418l-65.856545-65.853847c-3.810948-3.811816-8.844798-5.641487-13.840783-5.52176-0.146339-0.00307-0.287561-0.021489-0.4339-0.021489L440.541135 127.915321c-0.128942 0-0.254814 0.016373-0.382732 0.019443-4.979612-0.105401-9.991971 1.726318-13.789616 5.523807l-65.856545 65.853847L154.93593 199.312418c-9.848702 0-17.849238 7.984858-17.849238 17.850553 0 9.849322 8.000536 17.850553 17.849238 17.850553l214.203137 0c0.225137 0 0.444133-0.025583 0.667223-0.033769 5.0799 0.190335 10.221201-1.633197 14.097644-5.508457l65.856545-65.85487 124.462669 0 65.856545 65.85487c3.875419 3.876284 9.017744 5.698792 14.09662 5.508457 0.224113 0.008186 0.44311 0.033769 0.667223 0.033769l214.202113 0c9.848702 0 17.849238-8.001231 17.849238-17.850553C886.898981 207.297276 878.897422 199.312418 869.04872 199.312418zM672.592487 752.645802L672.592487 359.958188c0-9.866718-7.998489-17.84953-17.848215-17.84953s-17.851285 7.982812-17.851285 17.84953l0 392.687614c0 9.850345 8.001559 17.851577 17.851285 17.851577S672.592487 762.496148 672.592487 752.645802z"
                                                                            fill="#F56B6B" p-id="6456"></path>
                                                                    </svg></span>
                                                            </p>
                                                            <p style="margin-top: 2.142857142857143rem">
                                                                <download-excel id="c0b0a6" :fetch="DetailsFormConcat"
                                                                    :fields="json_fields" name="Company.xls">
                                                                    <el-popover placement="top" trigger="hover" popper-class="Risk-list-popover"
                                                                        content="Download Contacts">
                                                                        <span slot="reference"
                                                                            class="iconbg flex_center"><svg
                                                                                @click="exportCompanyWeb(item)"
                                                                                t="1733203232274" class="icon"
                                                                                viewBox="0 0 1024 1024" version="1.1"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                p-id="7306" width="2rem" height="2rem">
                                                                                <path
                                                                                    d="M485.6 437.6l-35.9-153.8c-2.9-18.1-15.6-33.1-32.9-39.1-15.1-5.1-31-7.8-46.9-7.7-4.5 0-9 0.2-13.5 0.6-76.6 8.4-134 74.2-132 151.2 3.8 232.1 191.9 418.9 424 421h2.6c76 0.9 140.5-55.6 149.6-131 1.9-20.3-0.5-40.8-7.2-60-6.3-18.3-22.6-31.3-41.9-33.4l-152.4-35c-3.7-0.8-7.5-1.3-11.3-1.3-13.4 0-26.2 5.4-35.6 15-5.7 6-15.7 16.7-25.5 28.9-11.3-6.4-22-13.7-32-22l-29.5-29.4c-8.3-9.9-15.7-20.5-22.1-31.8 10.1-8 19.8-16.4 29.1-25.4 12.3-12.1 17.5-29.8 13.6-46.6l-0.2-0.2z m-24.8 170c13.8 11.5 28.7 21.6 44.4 30.3 6.9 3.8 14.7 5.9 22.6 6 14 0 27.2-6.3 35.9-17.3 7.6-9.6 15.6-18.8 24.1-27.6l157.5 36.2 0.7-0.2c4.4 12.6 6 26.1 4.7 39.4-6.4 49.9-49.4 86.9-99.7 85.7h-1.8C444.5 757.2 278.8 592.7 274.5 388c-1.7-50.9 35.8-94.7 86.3-100.8 3-0.2 6-0.5 9-0.5 10.4 0 20.8 1.7 30.7 5l-0.2 0.7 36.5 156.4c-5.2 5-16.2 15-27.7 23.9-17.7 13.9-22.6 38.6-11.5 58.2 8.7 15.7 18.9 30.5 30.5 44.1l32.7 32.6z"
                                                                                    fill="#685ED1" p-id="7307"></path>
                                                                                <path
                                                                                    d="M898.5 284.2c11.8 0 21.4-9.5 21.4-21.3v-67.3c-0.4-72.8-59.7-131.7-132.5-131.6H238c-72.9-0.1-132.1 58.8-132.5 131.7v630.6C105.9 899.2 165.1 958 238 958h549.3c72.9 0.1 132.1-58.8 132.5-131.7V470.5c0-11.7-9.5-21.2-21.2-21.3-12 0.1-21.6 9.8-21.6 21.8v334c-0.4 61-50 110.3-111 110.2H259.5c-61 0-110.6-49.2-111-110.3v-588c0.4-61 50-110.3 111-110.3H766c61-0.1 110.6 49.2 111 110.2v45.9c0.1 11.9 9.7 21.5 21.5 21.5z"
                                                                                    fill="#685ED1" p-id="7308"></path>
                                                                                <path
                                                                                    d="M613.122 324.024h150.5c13.7 0 24.9-11.1 24.9-24.9s-11.1-24.9-24.9-24.9h-150.5c-13.7 0-24.9 11.1-24.9 24.9s11.1 24.9 24.9 24.9zM613.122 448.624h150.5c13.7 0 24.9-11.1 24.9-24.9 0-13.7-11.1-24.9-24.9-24.9h-150.5c-13.7 0-24.9 11.1-24.9 24.9 0 13.8 11.1 24.9 24.9 24.9z"
                                                                                    fill="#685ED1" p-id="7309"></path>
                                                                            </svg></span>
                                                                    </el-popover>
                                                                </download-excel>
                                                                <download-excel id="c0b0a6" :fetch="DetailsFormImport"
                                                                    :fields="json_fieldsImport" name="supply chain.xls">
                                                                    <el-popover placement="top" trigger="hover" popper-class="Risk-list-popover"
                                                                        content="Download Supply Chain List">
                                                                        <button slot="reference"
                                                                            :disabled="item.ieflag != '1'"
                                                                            
                                                                            class="margin20 iconbg flex_center">
                                                                            <svg @click="exportCompanyImport(item)"
                                                                                t="1733203128582" class="icon"
                                                                                viewBox="0 0 1024 1024" version="1.1"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                p-id="6884" id="mx_n_1733203128583"
                                                                                width="2rem" height="2rem">
                                                                                <path
                                                                                    d="M816.128 904.704l3.072-2.56 4.096 2.048c71.68 29.184 154.112-5.12 183.296-77.312 23.552-58.88 4.608-126.464-45.568-165.376l-3.072-2.56 0.512-4.608c5.632-30.208 9.216-59.904 9.216-89.6 0-196.096-124.928-370.176-310.784-432.128l-4.608-1.536-0.512-4.608C643.072 50.176 573.44-6.144 496.128 2.048 431.616 9.216 379.392 61.952 371.712 126.976l-0.512 4.608-4.096 1.536C180.736 195.584 56.32 369.152 56.32 565.248c0 32.768 2.56 61.44 9.216 88.576l0.512 4.608-3.072 2.56c-61.44 47.104-73.728 135.168-26.624 197.12 38.4 50.176 106.496 68.608 165.376 45.056l4.096-2.048 3.072 2.56c172.544 155.136 433.664 155.136 607.232 1.024z m155.648-142.848c0.512 3.072 0.512 7.68 0.512 11.776 0 48.128-36.352 89.6-84.48 95.232-4.096 0.512-7.68 0.512-11.776 0.512-48.128 0-90.112-35.84-95.744-84.48-6.656-52.736 31.232-101.376 83.456-107.52 53.76-5.632 101.888 32.256 108.032 84.48zM433.152 90.624c17.408-26.624 47.104-42.496 78.848-42.496 52.224 0 94.72 42.496 94.72 94.72s-42.496 94.72-94.72 94.72-94.72-42.496-94.72-94.72c0.512-17.92 5.632-35.328 15.872-52.224z m-200.192 716.8c-14.336 35.328-47.616 58.368-85.504 58.368-50.688 0-92.16-40.96-92.16-92.16 0-50.688 40.96-92.16 92.16-92.16 50.176 0 92.16 40.96 92.16 92.16 0 11.776-2.048 23.552-6.656 33.792z m16.896 72.704l-5.632-4.608 5.12-5.12c26.624-27.648 40.448-63.488 38.4-100.352-2.048-38.4-19.456-76.288-47.616-100.352-22.016-20.48-37.888-31.232-88.576-31.744-12.288 0-30.208 2.56-33.792 5.12l-9.216 5.12-1.536-9.728c-2.56-18.944-5.632-47.616-5.632-71.68 0-169.984 108.544-325.12 269.824-386.048l6.656-2.56 2.56 7.168c18.432 54.784 54.272 78.336 81.408 88.576 45.056 16.896 93.184 7.168 121.344-9.728 28.672-18.432 50.176-45.568 61.952-77.824l2.56-6.656 6.656 2.56c159.744 58.88 267.264 212.992 267.264 384 0 10.24-0.512 46.592-7.68 73.216l-2.048 5.632-5.632-0.512c-5.12-0.512-30.72-4.096-34.816-4.096-37.888 0.512-72.704 16.384-97.792 44.544-24.064 26.624-36.352 61.952-33.28 95.744 2.56 30.208 16.896 62.464 39.424 86.016l4.608 5.12-5.12 4.608c-71.168 62.464-167.936 98.816-265.728 98.816-96.768-0.512-189.44-34.816-263.68-95.232z"
                                                                                    p-id="6885" :fill="item.ieflag != '1'?'#CCCCCC':'#685ED1'"></path>
                                                                            </svg>
                                                                        </button>
                                                                    </el-popover>
                                                                </download-excel>
                                                                <el-popover placement="top" trigger="hover" popper-class="Risk-list-popover"
                                                                    content="Industry Info">
                                                                    <span slot="reference"
                                                                        class="margin20 iconbg flex_center" :class="{
                                                                            iconbgActive:
                                                                                NationalIndustryActive == index,
                                                                        }">
                                                                        <svg v-if="NationalIndustryActive == index"
                                                                            @click="NationalIndustry(item)"
                                                                            t="1733216471122" class="icon"
                                                                            viewBox="0 0 1112 1024" version="1.1"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            p-id="8059" width="2rem" height="2rem">
                                                                            <path
                                                                                d="M1046.556427 70.759203H565.146651V16.067592a16.067592 16.067592 0 0 0-16.067592-16.067592h-21.011467a16.067592 16.067592 0 0 0-16.067592 16.067592v54.691611H65.815329A65.506337 65.506337 0 0 0 0 136.26554V710.681955a65.506337 65.506337 0 0 0 65.815329 65.506337h401.689801l-130.085697 170.872662a34.916113 34.916113 0 0 0 0 44.185878 23.792396 23.792396 0 0 0 37.38805 0l154.496078-203.62583v-1.544961 211.041642a26.573325 26.573325 0 0 0 53.14665 0v-201.153893L741.581171 986.302957a24.101388 24.101388 0 0 0 37.079058 2.471937 35.225106 35.225106 0 0 0 2.162945-44.185878l-139.973446-168.091732h405.706699A65.506337 65.506337 0 0 0 1112.371756 710.681955V136.26554a65.506337 65.506337 0 0 0-65.815329-65.506337zM1059.534098 710.681955a12.97767 12.97767 0 0 1-12.977671 12.668679H65.815329a12.97767 12.97767 0 0 1-12.977671-12.668679V136.26554A12.668678 12.668678 0 0 1 65.815329 123.596862h980.741098a12.668678 12.668678 0 0 1 12.977671 12.668678z"
                                                                                fill="#FFFFFF" p-id="8060"></path>
                                                                            <path
                                                                                d="M905.038021 233.907061h-238.541944a26.573325 26.573325 0 0 0 0 53.146651h238.541944a26.573325 26.573325 0 0 0 0-53.146651zM905.038021 357.503923h-238.541944a26.573325 26.573325 0 0 0 0 53.14665h238.541944a26.573325 26.573325 0 0 0 0-53.14665z"
                                                                                fill="#FFFFFF" p-id="8061"></path>
                                                                            <path
                                                                                d="M639.922752 481.100785l251.519614 0 0 52.837658-251.519614 0 0-52.837658Z"
                                                                                fill="#FFFFFF" p-id="8062"></path>
                                                                            <path
                                                                                d="M639.922752 604.697646l198.681955 0 0 52.837659-198.681955 0 0-52.837659Z"
                                                                                fill="#FFFFFF" p-id="8063"></path>
                                                                            <path
                                                                                d="M326.604707 591.410984a167.78274 167.78274 0 1 1 0-335.256488V203.007846a220.92939 220.92939 0 1 0 220.620399 220.620398H494.387447a168.091732 168.091732 0 0 1-167.78274 167.78274z"
                                                                                fill="#FFFFFF" p-id="8064"></path>
                                                                            <path
                                                                                d="M372.95353 406.015691h132.248643a28.427278 28.427278 0 0 0 28.118286-33.989137c-11.741702-58.090525-48.82076-170.254677-157.585999-178.288473a29.045263 29.045263 0 0 0-30.899216 28.73627v154.496077a28.73627 28.73627 0 0 0 28.118286 29.045263z"
                                                                                fill="#FFFFFF" p-id="8065"></path>
                                                                        </svg>
                                                                        <svg v-else
                                                                            @click="NationalIndustry(item, index)"
                                                                            t="1733203174144" class="icon"
                                                                            viewBox="0 0 1112 1024" version="1.1"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            p-id="7052" width="2rem" height="2rem">
                                                                            <path
                                                                                d="M1046.556427 70.759203H565.146651V16.067592a16.067592 16.067592 0 0 0-16.067592-16.067592h-21.011467a16.067592 16.067592 0 0 0-16.067592 16.067592v54.691611H65.815329A65.506337 65.506337 0 0 0 0 136.26554V710.681955a65.506337 65.506337 0 0 0 65.815329 65.506337h401.689801l-130.085697 170.872662a34.916113 34.916113 0 0 0 0 44.185878 23.792396 23.792396 0 0 0 37.38805 0l154.496078-203.62583v-1.544961 211.041642a26.573325 26.573325 0 0 0 53.14665 0v-201.153893L741.581171 986.302957a24.101388 24.101388 0 0 0 37.079058 2.471937 35.225106 35.225106 0 0 0 2.162945-44.185878l-139.973446-168.091732h405.706699A65.506337 65.506337 0 0 0 1112.371756 710.681955V136.26554a65.506337 65.506337 0 0 0-65.815329-65.506337zM1059.534098 710.681955a12.97767 12.97767 0 0 1-12.977671 12.668679H65.815329a12.97767 12.97767 0 0 1-12.977671-12.668679V136.26554A12.668678 12.668678 0 0 1 65.815329 123.596862h980.741098a12.668678 12.668678 0 0 1 12.977671 12.668678z"
                                                                                fill="#685ED1" p-id="7053"></path>
                                                                            <path
                                                                                d="M905.038021 233.907061h-238.541944a26.573325 26.573325 0 0 0 0 53.146651h238.541944a26.573325 26.573325 0 0 0 0-53.146651zM905.038021 357.503923h-238.541944a26.573325 26.573325 0 0 0 0 53.14665h238.541944a26.573325 26.573325 0 0 0 0-53.14665z"
                                                                                fill="#685ED1" p-id="7054"></path>
                                                                            <path
                                                                                d="M639.922752 481.100785l251.519614 0 0 52.837658-251.519614 0 0-52.837658Z"
                                                                                fill="#685ED1" p-id="7055"></path>
                                                                            <path
                                                                                d="M639.922752 604.697646l198.681955 0 0 52.837659-198.681955 0 0-52.837659Z"
                                                                                fill="#685ED1" p-id="7056"></path>
                                                                            <path
                                                                                d="M326.604707 591.410984a167.78274 167.78274 0 1 1 0-335.256488V203.007846a220.92939 220.92939 0 1 0 220.620399 220.620398H494.387447a168.091732 168.091732 0 0 1-167.78274 167.78274z"
                                                                                fill="#685ED1" p-id="7057"></path>
                                                                            <path
                                                                                d="M372.95353 406.015691h132.248643a28.427278 28.427278 0 0 0 28.118286-33.989137c-11.741702-58.090525-48.82076-170.254677-157.585999-178.288473a29.045263 29.045263 0 0 0-30.899216 28.73627v154.496077a28.73627 28.73627 0 0 0 28.118286 29.045263z"
                                                                                fill="#685ED1" p-id="7058"></path>
                                                                        </svg>
                                                                    </span>
                                                                </el-popover>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <transition name="fade">
                                                        <div class="flex_box bottom-list-echarts margin-top20"
                                                            v-show="item.isRotated">
                                                            <div class="bottom-list-echarts-li">
                                                                <div class="flex_center_between_box">
                                                                    <div
                                                                        class="bottom-list-echarts-li-left flex_center_between_box">
                                                                        <div
                                                                            class="bottom-list-echarts-li-left-text flex_center_between_box">
                                                                            <el-tooltip
                                                                              
                                                                                effect="dark" content="Establishment year
                                                                                   " placement="right">
                                                                                 <span class="profit-txt">
                                                                                    Establishment year</span>
                                                                            </el-tooltip>
                                                                         
                                                                            <el-tooltip :disabled="item.prifeTeable?.legalStatus
                                                                                ?.registerDate?.length < 10"
                                                                                class="line_1 coll_child_name "
                                                                                effect="dark" :content="item.prifeTeable?.legalStatus
                                                                                    ?.registerDate" placement="right">
                                                                                <span class="color1290C9 profit-txt">{{
                                                                                    item.prifeTeable?.legalStatus
                                                                                        ?.registerDate
                                                                                }}</span>
                                                                            </el-tooltip>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="bottom-list-echarts-li-right flex_center_between_box">
                                                                        <div
                                                                            class="bottom-list-echarts-li-left-text flex_center_between_box">
                                                                            <span class="profit-txt"> Profit</span>
                                                                            <el-tooltip :disabled="item.prifeTeable?.financialStatus
                                                                                ?.profit?.length < 14"
                                                                                class="line_1 coll_child_name "
                                                                                effect="dark" :content="item.prifeTeable?.financialStatus
                                                                                    ?.profit" placement="right">
                                                                                <span class="color1290C9 profit-txt">{{
                                                                                    item.prifeTeable?.financialStatus
                                                                                        ?.profit
                                                                                    }}</span>
                                                                            </el-tooltip>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="flex_center_between_box">
                                                                    <div
                                                                        class="bottom-list-echarts-li-left flex_center_between_box">
                                                                        <div
                                                                            class="bottom-list-echarts-li-left-text flex_center_between_box">
                                                                            <el-tooltip
                                                                              
                                                                                effect="dark" content="  No. of Shareholders
                                                                                   " placement="right">
                                                                                   <span class="profit-txt">
                                                                                    No. of Shareholders</span>
                                                                            </el-tooltip>
                                                                          
                                                                            <span class="color1290C9 profit-txt">{{
                                                                                item.prifeTeable?.current
                                                                                    ?.shareholds
                                                                            }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="bottom-list-echarts-li-right flex_center_between_box">
                                                                        <div
                                                                            class="bottom-list-echarts-li-left-text flex_center_between_box">
                                                                          
                                                                            <el-tooltip 
                                                                                class="line_1 coll_child_name "
                                                                                effect="dark" content="Total Assets" placement="right">
                                                                                  <span class="profit-txt"> Total Assets</span>
                                                                            </el-tooltip>
                                                                   

                                                                            <el-tooltip :disabled="item.prifeTeable?.financialStatus
                                                                                ?.asset?.length < 14"
                                                                                class="line_1 coll_child_name "
                                                                                effect="dark" :content="item.prifeTeable?.financialStatus
                                                                                    ?.asset" placement="right">
                                                                                <span class="color1290C9 profit-txt">{{
                                                                                    item.prifeTeable?.financialStatus
                                                                                        ?.asset
                                                                                    }}</span>
                                                                            </el-tooltip>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="flex_center_between_box">
                                                                    <div
                                                                        class="bottom-list-echarts-li-left flex_center_between_box">
                                                                        <div
                                                                            class="bottom-list-echarts-li-left-text flex_center_between_box">
                                                                            <span class="profit-txt">
                                                                                Industry Code</span>
                                                                            <span class="color1290C9 profit-txt">{{
                                                                                item.prifeTeable?.current?.industryCode
                                                                                }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="bottom-list-echarts-li-right flex_center_between_box">
                                                                        <div
                                                                            class="bottom-list-echarts-li-left-text flex_center_between_box">
                                                                            <span class="profit-txt">
                                                                                Credit Rating</span>
                                                                            <span class="color1290C9 profit-txt">{{
                                                                                item.prifeTeable?.creditRatings
                                                                                    ?.creditRating
                                                                            }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="flex_center_between_box">
                                                                    <div
                                                                        class="bottom-list-echarts-li-left flex_center_between_box">
                                                                        <div
                                                                            class="bottom-list-echarts-li-left-text flex_center_between_box">
                                                                            <el-tooltip
                                                                              
                                                                                effect="dark" content="  No. of Employees
                                                                                   " placement="right">
                                                                                   <span class="profit-txt">
                                                                                    No. of Employees</span>
                                                                            </el-tooltip>
                                                                           
                                                                            <span class="color1290C9 profit-txt">{{
                                                                                item.prifeTeable?.current?.employee
                                                                                }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="bottom-list-echarts-li-right flex_center_between_box">
                                                                        <div
                                                                            class="bottom-list-echarts-li-left-text flex_center_between_box">
                                                                            <span class="profit-txt">
                                                                                Credit Score</span>
                                                                            <span class="color1290C9 profit-txt">{{
                                                                                item.prifeTeable?.creditRatings
                                                                                    ?.creditScore
                                                                            }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="flex_center_between_box">
                                                                    <div
                                                                        class="bottom-list-echarts-li-left flex_center_between_box">
                                                                        <div
                                                                            class="bottom-list-echarts-li-left-text flex_center_between_box">
                                                                            <span class="profit-txt"> Listed</span>
                                                                            <span class="color1290C9 profit-txt">{{
                                                                                item.prifeTeable?.legalStatus?.listed
                                                                                }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="bottom-list-echarts-li-right flex_center_between_box">
                                                                        <div
                                                                            class="bottom-list-echarts-li-left-text flex_center_between_box">
                                                                            <span class="profit-txt">
                                                                                ESG Rating</span>
                                                                            <span class="color1290C9 profit-txt">{{
                                                                                item.prifeTeable?.creditRatings
                                                                                    ?.ratingESG
                                                                            }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="flex_center_between_box">
                                                                    <div
                                                                        class="bottom-list-echarts-li-left flex_center_between_box">
                                                                        <div
                                                                            class="bottom-list-echarts-li-left-text flex_center_between_box">
                                                                            <span class="profit-txt"> Revenue</span>
                                                                            <el-tooltip :disabled="item.prifeTeable?.financialStatus
                                                                                ?.profit?.length < 14"
                                                                                class="line_1 coll_child_name "
                                                                                effect="dark" :content="item.prifeTeable?.financialStatus
                                                                                    ?.profit" placement="right">
                                                                                <span class="color1290C9 profit-txt">{{
                                                                                    item.prifeTeable?.financialStatus
                                                                                        ?.profit
                                                                                    }}</span>
                                                                            </el-tooltip>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="bottom-list-echarts-li-right flex_center_between_box">
                                                                        <div
                                                                            class="bottom-list-echarts-li-left-text flex_center_between_box">
                                                                            <span class="profit-txt"> DQI</span>
                                                                            <span class="color1290C9 profit-txt">{{
                                                                                item.prifeTeable?.creditRatings?.dqi
                                                                                }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div @click="setNews(item, 'prife')"
                                                                    class="MoreCompany">
                                                                    More Company Details
                                                                </div>
                                                            </div>
                                                            <div class="bottom-list-echarts-li" style="margin: 0 20px">
                                                                <div ref="ImportEchart"
                                                                    style="width: 100%; height: 16.4285rem"></div>
                                                            </div>
                                                            <div class="bottom-list-echarts-li">
                                                                <p class="bottom-list-echarts-head">
                                                                    Company News
                                                                </p>
                                                                <ul>
                                                                    <li class="flex_center_between_box"
                                                                        v-for="(ite, index) in item.NewstableData"
                                                                        :key="index">
                                                                        <el-tooltip class="item" effect="dark"
                                                                            :content="ite.titleEn" placement="top"
                                                                            :disabled="ite.titleEn?.length < 35">
                                                                            <div style="color: #8E86DD; cursor: pointer"
                                                                                @click="setid(ite)" class="news-text">
                                                                                {{ ite.titleEn }}
                                                                            </div>
                                                                        </el-tooltip>
                                                                        {{ ite.date }}
                                                                    </li>
                                                                </ul>
                                                                <div @click="setNews(item, 'news')" v-if="item.NewstableData?.length>6" class="MoreCompany">
                                                                    More Company News
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </transition>
                                                </li>
                                            </transition-group>
                                        </draggable>
                                    </ul>
                                </div>
                            </div>
                            <div class="risk-right" v-if="NationalIndustryShow">
                                <div class="flex_center_between_box" style="margin-bottom: 20px">
                                    <p style="font-family: DMSans Bold;margin-bottom: 0px;">National Industry Data</p>
                                    <div class="flex_center">
                                        <span class="Upadetime">Last Update: {{ LastUpdate }}</span><svg t="1733120402127"
                                            @click="rifghtUpdate()" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                            xmlns="http://www.w3.org/2000/svg" p-id="14841"
                                            width="1.5714285714285714rem" height="1.5714285714285714rem">
                                            <path
                                                d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                                                fill="#1A2332" p-id="14842"></path>
                                        </svg>
                                    </div>
                                </div>

                                <div class="risk-right-content">
                                    <div class="risk-right-content-title">
                                        Industry and Country Overview
                                    </div>
                                    <div class="flex_center_between_box">
                                        <div class="left-txt">Country Name</div>
                                        <div style="width: 50%" class="right-txt">
                                            {{ CompanyObj?.countryName }}
                                        </div>
                                    </div>

                                    <div class="flex_center_between_box margin16">
                                        <div class="left-txt">Business Environment</div>
                                        <div style="width: 50%" class="right-txt">
                                            {{ CompanyObj?.businessEnvironment }}
                                        </div>
                                    </div>
                                    <div class="flex_center_between_box margin16">
                                        <div class="left-txt">Legal Environment l</div>
                                        <div style="width: 50%" class="right-txt">
                                            {{ CompanyObj?.legalEnvironment }}
                                        </div>
                                    </div>
                                    <div class="flex_center_between_box margin16">
                                        <div class="left-txt">Confidence Index</div>
                                        <div style="width: 50%" class="right-txt">
                                            {{ CompanyObj?.confidenceIndex }}
                                        </div>
                                    </div>
                                    <div class="flex_center_between_box margin16">
                                        <div class="left-txt">National Competitiveness Index</div>
                                        <div style="width: 50%" class="right-txt">
                                            {{ CompanyObj?.nationalCompetitivenessIndex }}
                                        </div>
                                    </div>
                                    <div class="flex_center_between_box margin16">
                                        <div class="left-txt">National GDP</div>
                                        <div style="width: 50%" class="right-txt">
                                            {{ CompanyObj?.nationalGDP | FilterNum }}
                                        </div>
                                    </div>
                                </div>
                                <div class="risk-right-content">
                                    <div class="risk-right-content-title">
                                        Industry situation of the affiliated company
                                    </div>
                                    <div class="flex_center_between_box">
                                        <div class="left-txt">
                                            Subject company industry descripti
                                        </div>
                                        <div style="width: calc(100% - 180px)" class="right-txt">
                                            {{ CompanyObj?.targetCompanyIndustryDescription }}
                                        </div>
                                    </div>

                                    <div class="flex_center_between_box margin16">
                                        <div class="left-txt">Target enterprise industry code</div>
                                        <div style="width: 50%" class="right-txt">
                                            {{ CompanyObj?.targetEnterpriseIndustryCode }}
                                        </div>
                                    </div>
                                </div>
                               <div class="risk-right-content"
                                    v-if="CompanyObj?.industryScaleSegmentation?.length > 0">
                                    <div class="risk-right-content-title">
                                        Industry scale segmentation
                                    </div>
                                    <el-table empty-text="No Data" :data="CompanyObj?.industryScaleSegmentation"
                                        style="width: 100%" row-class-name="highlight-row"
                                        :cell-class-name="cellClassName">
                                        <el-table-column label="" prop="desc" style="height: 58px" >
                                            <template slot-scope="scope">
                                                <span class="table-content">{{ scope.row.desc }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Quantity" align="center" prop="data"
                                            show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <span class="table-content">{{ scope.row.data }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Subject Company" align="center" prop="sameIndustry"
                                            show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <span class="table-content">
                                                    <svg v-if="scope.row.target == 'true'" t="1733191208945"
                                                        class="icon" viewBox="0 0 1024 1024" version="1.1"
                                                        xmlns="http://www.w3.org/2000/svg" p-id="5869" width="26"
                                                        height="26">
                                                        <path
                                                            d="M939.36 218.912a32 32 0 0 1 45.856 44.672l-538.016 552a32 32 0 0 1-43.776 1.92L63.872 526.048a32 32 0 1 1 41.696-48.544l316.768 271.936L939.36 218.88z"
                                                            fill="#55B419" p-id="5870"></path>
                                                    </svg></span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="risk-right-content" v-if="CompanyObj?.industryYearSegmentation?.length > 0">
                                    <div class="risk-right-content-title">
                                        Industry year segmentation
                                    </div>
                                    <el-table empty-text="No Data" :data="CompanyObj?.industryYearSegmentation"
                                        style="width: 100%" row-class-name="highlight-row"
                                        :cell-class-name="cellClassName">
                                        <el-table-column label="" prop="desc" style="height: 58px" width="340" show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <span class="table-content">{{ scope.row.desc }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Quantity" align="center" prop="SubiectCompany"
                                            show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <span class="table-content">{{ scope.row.data }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Subject Company" align="right" prop="sameIndustry"
                                            show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <span class="table-content">
                                                    <svg v-if="scope.row.target == 'true'" t="1733191208945"
                                                        class="icon" viewBox="0 0 1024 1024" version="1.1"
                                                        xmlns="http://www.w3.org/2000/svg" p-id="5869" width="26"
                                                        height="26">
                                                        <path
                                                            d="M939.36 218.912a32 32 0 0 1 45.856 44.672l-538.016 552a32 32 0 0 1-43.776 1.92L63.872 526.048a32 32 0 1 1 41.696-48.544l316.768 271.936L939.36 218.88z"
                                                            fill="#55B419" p-id="5870"></path>
                                                    </svg></span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="risk-right-content"
                                    v-if="CompanyObj?.industryOperationSituation?.length > 0">
                                    <div class="risk-right-content-title">
                                        Industry operation situation
                                    </div>
                                    <el-table empty-text="No Data" :data="CompanyObj?.industryOperationSituation"
                                        style="width: 100%" row-class-name="highlight-row"
                                        :cell-class-name="cellClassName">
                                        <el-table-column label="" prop="desc" show-overflow-tooltip style="height: 58px" >
                                            <template slot-scope="scope">
                                                <span class="table-content">{{ scope.row.desc }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Quantity" align="center"  prop="SubiectCompany"
                                            show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <span class="table-content">{{ scope.row.data }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Subject Company" align="right" prop="sameIndustry"
                                            show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <span class="table-content">
                                                    <svg v-if="scope.row.target == 'true'" t="1733191208945"
                                                        class="icon" viewBox="0 0 1024 1024" version="1.1"
                                                        xmlns="http://www.w3.org/2000/svg" p-id="5869" width="26"
                                                        height="26">
                                                        <path
                                                            d="M939.36 218.912a32 32 0 0 1 45.856 44.672l-538.016 552a32 32 0 0 1-43.776 1.92L63.872 526.048a32 32 0 1 1 41.696-48.544l316.768 271.936L939.36 218.88z"
                                                            fill="#55B419" p-id="5870"></path>
                                                    </svg></span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="CompanyCompany right_cont_box" v-show="Compare">
                        <compareCompanys :compareList="compareList" @CompareShowfalse="CompareShow($event)">
                        </compareCompanys>
                    </div>
                </div>
            </div>
        </div>
        <QuestionExport :suoClose="ExportDialogSuo" @closeExportDialog="ExportDialog($event)"></QuestionExport>
        <CompanyUpdate :suoClose="UpdateDialogSuo" @closeUpdateDialog="UpdateDialog($event)"></CompanyUpdate>

        <QuestionSaved :suoClose="SavyeLeadsSuo" :Saved="Saved" @closeSaveDialog="SavedcloseDialog($event)">
        </QuestionSaved>
        <el-dialog :visible.sync="deledeLaeadsDialog" center :close-on-click-modal="true"
            @close="deledeLaeadsDialog = false" custom-class="dialog_normalsuo dialog_normalpower" :append-to-body="true">
            <div>
                <div class="detail_cont">
                       <div class="flex_center margin-bottom20"><img style="width: 5.7142857rem;height: 5rem;" src="../../../assets/dialogIcoImg/ExportTips.png" alt=""></div>
                     <h3 class="dialog_normal_question-head">Tips</h3>
                       <div class="detail_cont_text" style="padding: 0px;text-align: center;margin-top: 20px !important;">
                        Are you sure you want to delete this data
                    </div>
                </div>
            </div>
            <div class="flex_center" style="margin-top: 20px">
                <el-button class="btn_export leadsDialogD8850 riskButton" @click="deledeLaeadsDialog = false">Cancel</el-button>
                <el-button class="btn_export questionExportButtonactive riskButton" style="margin-left: 30px"
                    @click="deLaeadsDialogubmit()">OK</el-button>
            </div>
        </el-dialog>
        <Login :loginAndCreatePop.sync="loginDialog"></Login>
    </div>
    <!--srcviewscompanylistriskvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import draggable from "vuedraggable";
import { findPartnerDetail } from "@/api/searchApi.js";
import CompanyQuestion from "./getCompany/CompanyQuestionTwo.vue";
import CompanyUpdate from "./getCompany/QuestionUpdate.vue";
import QuestionExport from "./getCompany/QuestionExport.vue";
import rectcard from "../../../components/rectCard/index.vue";
import content_text from "../../../components/text_content/index.vue";
import gui_card from "../../../components/gui_card/gui_card.vue";
import { addItems, getLeadsQuestions } from "@/api/userApi";
import { findPartnerPcnotDing } from "../../../api/searchApi";
import compareCompanys from "./compareCompanys";
import QuestionSaved from "./getCompany/QuestionSaved.vue";
import Login from "@/components/login.vue";

import {
    getCompanyIndustryInfo,
    getCompanyDetail,
    getPdfLink,
    getsearchExport,
    getHuokePartPrivilege,
    searchMoreEmail,
    leadsPostFilter,
 

} from "@/api/companyApi.js";
import { mixins1 } from "@/mixins/index";
export default {
    name: "",
    props: {},
    watch: {
        "$store.state.app.SeachLabels": {
            handler(newVal, oldVal) {
                // 在这里处理columns属性的变化
                // if(newVal!=''){
                // this.SearchLeadsSuo=false
                if (newVal) {
                    this.chageItTrue=false
                    this.chageItIndex=0
                    this.getSearchListType=1
                this.Compare=false
                this.checked=false
            this.compareList=[]
            this.$store.dispatch("app/setcollectList", []);
            this.$store.dispatch("app/setchangeList",  this.compareList);
             this.setToolsAcive()
             this.NationalIndustryShow=false
             this.NationalIndustryActive=undefined
            this.RiskLoding=true
                 if(this.isNewQuestion){
                    this.$store.dispatch("app/SetSeachLabels", '');
                    this.SaveMyAnswer()
                 }else{
                    this.labelsCode = newVal;
                    this.leadsPostFilterList = null
                    this.findPartnerDetailList();
                 }
                    
                    
                   
               
                }

                // this.page.pageNo = 1
                //   this.parentTable = []
                //   this.searchCompanyByName()
            },

            deep: true, // 深度监听，可以监听对象内部属性的变化
            immediate: true, // 立即执行一次handler函数，即使columns没有变化
        },

        isOpenSlct: {
            handler(newVal, oldVal) {
                this.isOpenSlct = newVal;
                // 在这里处理columns属性的变化
                if (newVal == false) {
                                   this.checked=false
            this.compareList=[]
            this.$store.dispatch("app/setcollectList", []);
            this.$store.dispatch("app/setchangeList",  this.compareList);
            this.CompanyList.map(item=>{
                item.isChecked=false
            })
            this.setToolsAcive();
                    
                }

                // 这里可以进行一些逻辑处理或者触发其他操作
            },

            deep: true, // 深度监听，可以监听对象内部属性的变化
            immediate: true, // 立即执行一次handler函数，即使columns没有变化
        },
        token: {
            handler(newVal, oldVal) {
                if (newVal) {
                } else {
                    this.setToolsfalse();
                }
            },
            immediate: true,
        },
        Compare: {
            handler(newVal, oldVal) {
                this.Compare = newVal;
                if (this.Compare) {
                    // this.setToolsfalse();
                } else {
                    this.compareList.map((item) => {
                        item.isChecked = false;
                        this.setToolsAcive();
                    });
                }
                // 在这里处理columns属性的变化
            },

            deep: true, // 深度监听，可以监听对象内部属性的变化
            immediate: true, // 立即执行一次handler函数，即使columns没有变化
        },
        ReSelectCriteria: {
            handler(newVal, oldVal) {

                this.chageItTrue=false
                this.chageItIndex=0
                this.getSearchListType=1
                // this.$refs.CompanyQuestion.percentage = 25;
                // this.$refs.CompanyQuestion.$refs.carousel.setActiveItem(0);
                // this.$refs.CompanyQuestion.currentIndex = 0;
                if (oldVal != undefined) {
                    // this.isNewQuestion=true
                    this.SaveAnswer = false
                    this.leadsPostFilterList=[]
                    this.NationalIndustryShow=false
                    this.NationalIndustryActive=undefined
                    this.$refs.CompanyQuestion.questionWentiDialog = true;
                    this.$store.dispatch("app/SetSeachLabels", '');
                    this.$refs.CompanyQuestion.SavedAnswerIndexActive = undefined
                    this.isNewQuestion=false
                    // this.$store.commit("setRefreshKey", new Date().getTime());
                    this.CompanyQuestionShow = true;
                }
            },
            deep: true, // 深度监听，可以监听对象内部属性的变化
            immediate: true, // 立即执行一次handler函数，即使columns没有变化
        },
        Saved: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.Saved = newVal;
                    this.SavyeLeadsSuo = true;

                    this.CompanyQuestionShow = false
                }

                // 在这里处理Sort属性的变化
            },
            deep: true, // 深度监听，可以监听对象内部属性的变化
            immediate: true, // 立即执行一次handler函数，即使columns没有变化
        },
        Update: {
            handler(newVal, oldVal) {
             
                if(oldVal!=undefined){
                    this.Update = newVal;
                    this.ExportDialogSuo = true;

                }
                // if (newVal) {
                // }

                // 在这里处理columns属性的变化
            },

            deep: true, // 深度监听，可以监听对象内部属性的变化
            immediate: true, // 立即执行一次handler函数，即使columns没有变化
        },
        Export: {
            handler(newVal, oldVal) {
                if(oldVal!=undefined){
                this.UpdateDialogSuo = true;

                }
                // if (newVal) {
                //     this.UpdateDialogSuo = true;
                // }
                // this.Export = newVal;
                // 在这里处理columns属性的变化
            },
            deep: true, // 深度监听，可以监听对象内部属性的变化
            immediate: true, // 立即执行一次handler函数，即使columns没有变化
        },
    },
    mixins: [mixins1],
    components: {
        gui_card,
        rectcard,
        content_text,
        CompanyQuestion,
        draggable,
        QuestionExport,
        CompanyUpdate,
        QuestionSaved,
        compareCompanys,
        Login,
    },

    data() {
        return {
            PCMoudele:[],
            LastUpdate:'',
            loginDialog:false,
            deledeLaeadsDialog: false,
            InsdustryTable: [],
            companyIncomes: [],
            FilterIndex: 1,
            isNewConfirm:false,
            ComanyFilterList: [
            ],
            isShowTooltip: false,
            leadsPostFilterList: null,
            RiskLoding:false,
            FilterList: [
                {
                    name: 'Filters'
                },
                {
                    name: 'Questionnaire'
                }
            ],
            json_fields: {
                "companyTag": "companyTag",
                department: "department",
                email: "email",
                name: 'name',
                phone: 'phone',
                position: 'position',
                linkedin: 'linkedin'
            },
            json_fieldsImport: {
                Date: "ie_date",
                Products: "hscode_description_inter",
                "Buyer Names": "import_name",
                Destination: "import_country_inter",
                "Supplier Names": "export_name",
                Origin: "export_country_inter",
                Amount: "amount",
            },
            CompanyObj: {},
            newVal: null,
            DetailsForm: [],
            situationtableData: [],
            distributiontableData: [],
            SaveDialog: false,
            SavyeLeadsSuo: false,
            ExportDialogSuo: false,
            UpdateDialogSuo: false,
            ReSelectCriteria: false,
            templateName: "",
            Compare: false,
            Export: false,
            compareList: [],
            getSearchListType:1,
            Update: false,
            totle: 0,
            checked: "",
            pageNo: 1,
            tproductseName: "Electricity, gas, steam and air co…",
            disabled: false,
            NationalIndustryActive: "null",
            isRotated: false,
            newDialog: false,
            CompanyQuestionShow: true,
            NationalIndustryShow: false,

            isOpenSlct: false,
            Compare: false,
            checkList: [],
            aaaid: "",
            urposeValue: "选项1",
            purposeoptions: [
                {
                    value: "选项1",
                    label: "Test data",
                },
                {
                    value: "选项2",
                    label: "Test data",
                },
            ],
            CompanyList: [],
            token: localStorage.getItem("token"),
            Saved: undefined,
            isChecked: "",
            tableData: [],
            NewstableData: [],
            DetailsFormImportlist: [],
            riskTotal:'',
            QuestionPageList: [],
            DelIndex: undefined,
            ImporttableData: [],
            leadsList: [],
           leadsListModuleCode:'',
            cascaderProps: {
                // 这里设置最后一层可以多选
                multiple: false,
                checkStrictly: false, // 允许选择不严格
                emitPath: false, // 不发出路径
                label: "optionsContent", // 显示的标签
                value: "id", // 选中的值
                children: "list",
                SaveAnswer: false,
                itemList: {},
                // 其他属性可以根据需要添加
            },
            page: {
                    pageNo: 1,
                    pageSize: 100,
                    total: 0,
                },
            CompanyQuestionList: [],
            isNewQuestion:false,
            CompanyListRandom:[],
            chageItIndex:0,
            chageItTrue:false,
        };
    },
    methods: {
        getSearchListTypecode(){
            this.chageItIndex=0
            this.getSearchListType++
            
            let typenum=this.CompanyQuestionList[1].selectedCodes.optionsCode=='SC1001'?3:2
 if( this.getSearchListType>typenum){
            this.getSearchListType=1
           }
          
         
        },
        ChangeIt(){
            // this.chageItTrue如果点其他的模型不再变化
            this.chageItIndex++
            
            if(this.chageItIndex>2&&!this.chageItTrue){
                        this.getSearchListType++
            let typenum=this.CompanyQuestionList[1].selectedCodes.optionsCode=='SC1001'?3:2
 if( this.getSearchListType>typenum){
            this.getSearchListType=1
           }
           this.chageItIndex=0
          this.getleadsPostFilter()
          
            }else{
                this.RiskLoding=true
            setTimeout(() => {
                this.NationalIndustryShow=false
            this.NationalIndustryActive=undefined
            // 获取订的数据
            const countTrueDing = this.CompanyList.filter(item => item.isDing == true)
            // 从钉盛下的数据过滤
            let filteredData =  this.CompanyListRandom.filter(item => !item.isDing)
        //  下20条数句
            const randomItems = this.getRandomItems(filteredData, 20-(countTrueDing?.length));
        //  合并订的
            this.CompanyList=[...countTrueDing, ...randomItems]
            this.CompanyList.map(item=>{
                item.isRotated=false
                item.isChecked=false
            })

            this.RiskLoding=false
            }, 400);
            }
      
       
               this.checked=false
            this.compareList=[]
            this.$store.dispatch("app/setcollectList", []);
            this.$store.dispatch("app/setchangeList",  this.compareList);
            this.setToolsAcive();
        },
        getRandomItems(arr, count) {
            // 随机
  const shuffled = arr.sort(() => 0.5 - Math.random()); // 随机打乱数组
  return shuffled.slice(0, count); // 返回前 count 条数据
},

        rifghtUpdate() {
            this.NationalIndustryShow = false;
            this.NationalIndustryActive = 'null'
            this.$nextTick(() => {
                this.resizeFn()

            })
        },
      // echarts监听 浏览器宽度改变 echarts改变
        resizeFn() {
            this.CompanyList.map(item => {
                if (item.chartInstance !== null) {
                    item.chartInstance.resize()
                }
            })

        },
        menuCheck(value) {
            let arr2 = []
            this.ComanyFilterList.forEach((item, index) => {
                if (item.selectedCodes != null && item.selectedCodes != undefined && item.selectedCodes.length > 0) {
                    arr2.push({
                        questionCode: item.leadsQuestions.code,
                        selected: item.selectedCodes,
                    });
                }
            })
            this.leadsPostFilterList = arr2
            this.getleadsPostFilter()
            this.$store.dispatch("app/setchangeList", []);
            this.$store.dispatch("app/setcollectList", []);
            this.setToolsAcive();
            this.checked = false
            this.NationalIndustryShow=false
            this.NationalIndustryActive=undefined


        },
        onMouseOver(str, i) {
            const tag = this.$refs.str[i];
            const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
            const contentWidth = tag.offsetWidth; // 获取元素可视宽度
            this.isShowTooltip = contentWidth <= parentWidth;
        },
        // feliter切换
        FilterChange(index) {
            if(this.PCMoudele[8].hasPrivilege){
                this.FilterIndex = index
            }else{
                this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
            }
        },
        // 获取权限
        getHuokePartPrivilegeList() {
            getHuokePartPrivilege({
                moduleType: 7
            }).then(res => {
                if (res.code == 200) {
                    this.PCMoudele=res.data
                }
            }

            )
        },
        SaveMyAnswer() {
            // 是否点击save
            if(this.PCMoudele[5].hasPrivilege){
                this.$refs.CompanyQuestion.templateName=''
            this.$refs.CompanyQuestion.SaveDialog = true;
            if(this.$store.state.app.SeachLabels!=''){
                this.SaveAnswer = true
                this.isNewQuestion=false
            
            }else{
                this.SaveAnswer = false
                this.isNewQuestion=true
            }
            //

            }else{
                this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
            }
       
        },
        getPantentList(value) {
            this.CompanyQuestionList = value;
            this.CompanyQuestionList.map(item => {
                if (Array.isArray(item.selectedCodes)) {
                    if (item.selectedCodes.length == 0) {
                        item.selectedCodes = null
                    }
                    if (item.leadsQuestions.type == 9) {
                        item.leadsOptions = item.selectedCodes
                    }

                }
            })

            let arr1 = [];

            value.map((item, index) => {


                if (item.selectedCodes != null && item.selectedCodes != undefined) {
                    if (Array.isArray(item.selectedCodes)) {
                 
                        arr1.push({
                            questionCode: item.leadsQuestions.code,
                            selected: item.selectedCodes.map((item) => {
                                return item.optionsCode;
                            }),
                        });
                        // }

                    } else {
                        if (item.leadsQuestions.type == 7) {
                            arr1.push({
                                questionCode: item.leadsQuestions.code,
                                selected: [item.selectedCodes],
                            });
                        } else {
                            arr1.push({
                                questionCode: item.leadsQuestions.code,
                                selected: [item.selectedCodes.optionsCode],
                            });
                        }
                    }

                }
            });
            this.leadsList = arr1
  
            this.labelsCode = ''
                      this.leadsListModuleCode=arr1[1].selected[0]

            this.getleadsPostFilter()
        },
        // web导出
        exportCompanyWeb(item) {
            this.chageItTrue=true
            if(this.PCMoudele[14].hasPrivilege){
                this.aaaId = item.aaa_id;
                this.itemList = item
            }else{
                this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
            }
           
            // this.DetailsForm = [];
            // this.DetailsForm.push(item);
        },
        DetailsFormConcat() {
            this.chageItTrue=true
            if(this.PCMoudele[15].hasPrivilege){
            let params = {
                page: 1,
                pageSize: 100,
                id3a: this.aaaId,
                website: this.itemList.web_site,
                countryCode: this.itemList.company_country,


            }
            //    return   this.DetailsFormImportlist
            return searchMoreEmail(params).then((res) => {
                if (res.code == 200) {
                    if(res.data.contacts.length==0){
                        this.$message({
                                message: 'No Data',
                                type: 'success'
                            })
                    }else{
                        this.$message({
                                message:res.msg,
                                type: 'success'
                            })
                    }
                    return res.data.contacts;
                   
                 
                } else {
                    return [];
                }
            });
        }
        },
        DetailsFormImport() {
            this.chageItTrue=true
            if(this.PCMoudele[15].hasPrivilege){
                return getsearchExport({
                page: 1,
                pageSize: 100,
                export_aaaid: this.aaaId,
                import_aaaid: this.aaaId,
            }).then((res) => {
                if (res.code == 200) {
                    if(res.data.rows.length==0){
                        this.$message({
                                message: 'No Data',
                                type: 'success'
                            })
                    }else{
                        this.$message({
                                message:res.msg,
                                type: 'success'
                            })
                    }
                    return res.data.rows;

                  
                } else {
                    return [];
                }
            });
            }
      
        },
        // 贸易链路导出
        exportCompanyImport(item) {
            this.chageItTrue=true
            if(this.PCMoudele[15].hasPrivilege){
                this.aaaId = item.aaa_id;
            }else{
                this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
            }
           
        },

        // 点击跳转
        setNews(row, detail) {
            
            if (this.token) {
                this.chageItTrue=true
                // sessionStorage.setItem("company", JSON.stringify(row));
                let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
                    .countryList;
                let SACode1 = "";
                newscountry.map((item) => {
                    if (item.countryCode == row.company_country) {
                        SACode1 = item.dowjonesCountrycode;
                    }
                });
                let routeData = "";
                if (detail == "prife") {
                    routeData = this.$router.resolve({
                        path:
                            "/index/company/detals/" +
                            row.aaa_id +
                            "/background/snapshot?id3a=" +
                            row.aaa_id +
                            "&companyCountry=" +
                            row.company_country +
                            "&SACode1=" +
                            SACode1 +
                            "&companyName=" +
                            row.company_name_en+
                            '&keword='+this.$route.query.keword,
                    });
                } else {
                    routeData = this.$router.resolve({
                        path:
                            "/index/company/detals/" +
                            row.aaa_id +
                            "/publications/news?id3a=" +
                            row.aaa_id +
                            "&companyCountry=" +
                            row.company_country +
                            "&SACode1=" +
                            SACode1 +
                            "&idpower=442" +
                            "&companyName=" +
                            row.company_name_en+
                            '&keword='+this.$route.query.keword,
                    });
                }

                window.open(routeData.href, "_blank");
            }
        },
        //新闻跳转
        setid(row) {
            if (row.link == undefined) {
                getPdfLink({ articleRef: row.id }).then((res1) => {
                    // let res1 = JSON.parse(crypto.decrypt(res));

                    if (res1.data.includes("http")) {
                        let routeData = res1.data;
                        window.open(routeData, "_blank");
                    } else {
                        let routeData = "http://" + res1.data;
                        window.open(routeData, "_blank");
                    }
                    // let routeData = res1.data;
                    // window.open(routeData, '_blank');
                });
            }
            if (row.link.includes("http")) {
                let routeData = row.link;

                window.open(routeData, "_blank");
            } else {
                let routeData = "http://" + row.link;
                window.open(routeData, "_blank");
            }
            // let routeData = row.url;
            // window.open(routeData, '_blank');
        },
        // 获取公司详情数据
        getCompanyDetailList(item, index) {
            this.chageItTrue=true
            if(this.PCMoudele[11].hasPrivilege){
            item.isRotated = !item.isRotated;

            if (item.isRotated) {
                getCompanyDetail({
                    aaaId: item.aaa_id,
                    countryCode: item.company_country,
                    industryCode: item.isic_code,
                }).then((res) => {
                    // 更新数据
                    item.NewstableData = res.data.news;
                    item.prifeTeable = res.data.snapshotVO;
                    item.InsdustryTable = res.data.incomePanel.industryIncomes;
                    item.companyIncomes = res.data.incomePanel.companyIncomes;

                    // 图表配置
                    const option = {
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "cross",
                            },
                        },
                        grid: {
                            left: "0%",
                            right: "0%",
                            top: "12%",
                            bottom: "0%",
                            containLabel: true,
                        },
                        legend: {
                            right: "10px",
                            top: "0px",
                        },
                        xAxis: [{
                            type: "category",
                            data: item.companyIncomes.map((item) => item.year),
                            axisTick: {
                                show: false,
                            },
                        },
                        {
                            type: "category",
                            data: item.InsdustryTable.map((item) => item.year),
                            axisTick: {
                                show: false,
                            },
                            axisLabel:{
                                show:false
                            }
                        },
                    ],
                        yAxis: [
                            {
                                type: "value",
                                axisLabel: {
                                    formatter: "{value} ",
                                    show: false,
                                },
                            },
                            {
                                type: "value",
                                axisLabel: {
                                    formatter: "{value} ",
                                    show: false,
                                },
                            },
                        ],
                        series: [
                            {
                                name: "Industry Mean",
                                type: "bar",
                                barWidth: "15",
                                itemStyle: { color: "#8E86DD" },
                                emphasis: {
                                    itemStyle: {
                                        color: "#8E86DD",
                                    },
                                },
                                data: item.InsdustryTable.map((item) => item.income),
                            },
                            {
                                name: "Target Subject Revenue",
                                type: "line",
                                barWidth: "20",
                                yAxisIndex: 1,
                                itemStyle: { color: "#FF7600" },
                                emphasis: {
                                    itemStyle: {
                                        color: "#FF7600",
                                    },
                                },
                                data: item.companyIncomes.map((item) => item.income),
                            },
                        ],
                    };

                    // 获取图表 DOM
                    const chartDom = this.$refs.ImportEchart[index];
                    let chart = this.$echarts.getInstanceByDom(chartDom);

                    // 如果没有找到图表实例，则初始化一个新的图表
                    if (!chart) {
                        chart = this.$echarts.init(chartDom);
                        item.chartInstance = chart; // 存储图表实例
                    } else {
                        // 如果找到了图表实例，先销毁它
                        chart.dispose();
                        // 重新初始化图表
                        chart = this.$echarts.init(chartDom);
                        item.chartInstance = chart; // 更新存储的图表实例
                    }

                    // 设置图表选项
                    this.$nextTick(() => {
                        if (chart) {
                            chart.setOption(option); // 仅在 chart 存在时设置选项
                        }
                    });

                    // 更新数据
                    this.$set(item, "item.NewstableData", res.data.news);
                    // this.CompanyList[index].chartInstance = chart; // 更新 CompanyList 中的图表实例
                }).catch((error) => {
                    console.error("error:", error);
                });
            }
        }else{
            this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
        }
        },
        // 公司对比返回
        CompareShow(val) {
            this.Compare = false;
            this.checked = ""
            this.$store.dispatch("app/setchangeList", []);
            this.$store.dispatch("app/setcollectList", []);
            this.setTools();
        },
        setToolsfalse() {
            this.$store.dispatch("app/setTools", {
                name: "select",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "edit",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "sort",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "collect",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "saved",
                key: "isActive",
                value: false,
            });

            this.$store.dispatch("app/setTools", {
                name: "compare",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "export",
                key: "isActive",
                value: false,
            });

            this.$store.dispatch("app/setTools", {
                name: "update",
                key: "isActive",
                value: false,
            });

            this.$store.dispatch("app/setTools", {
                name: "download",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "reportError",
                key: "isActive",
                value: false,
                
            });
            this.$store.dispatch("app/setTools", {
                name: "share",
                key: "isActive",
                value: false,
            });
        },
        // 工具栏高亮控制
        setToolsAcive() {
            this.$store.dispatch("app/setTools", {
                name: "Optimize",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "filter",
                key: "isActive",
                value: true,
            });
            this.$store.dispatch("app/setTools", {
                name: "menu",
                key: "isActive",
                value: true ,
            });
            this.$store.dispatch("app/setTools", {
                name: "sort",
                key: "isActive",
                value: false && this.token,
            });
            this.$store.dispatch("app/setTools", {
                name: "select",
                key: "isActive",
                value: true && this.token,
            });
            this.$store.dispatch("app/setTools", {
                name: "edit",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "collect",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "saved",
                key: "isActive",
                value: true,
            });
            this.$store.dispatch("app/setTools", {
                name: "compare",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "export",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "update",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "download",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "reportError",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "share",
                key: "isActive",
                value: false,
            });

            //   this.$store.dispatch("app/setTools", "filter",'isActive',false);
        },
        // 收藏

        CollectCheckBook() {
            this.checkList = this.$store.state.app.collectList;
            let collect = [];
            this.$store.state.app.changeList.map((item) => {
                collect.push(item.aaa_id);
            });

            // this.$store.state.app.changeLis;
            this.checkList.forEach((item) => {
                addItems({
                    collectionId: item,
                    items: collect,
                }).then((Res) => {
                    if (Res.code == 200) {
                        this.CompanyList.map(ite => {
                            if (collect.includes(ite.aaa_id)) {
                                ite.isFavorite = true
                            }
                        })

                        // this.$router.go(0);
                        this.$message({
                            message: Res.msg,
                            center: true,
                            type: "success",
                        });
                    } else {
                        this.$message({
                            message: Res.msg,
                            center: true,
                            type: "error",
                        });
                    }
                });
            });
        },
        findPartnerDetailList() {
            let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
            getLeadsQuestions({
                leadsAnswersHead: {
                    id: this.labelsCode,
                    userId: userinfo.id,
                    title: null,
                    creatTime: null,
                    updateTime: null,
                },
            }).then((res) => {
                if (res.code == 200) {
                    this.CompanyQuestionShow = false;
                    this.CompanyQuestionList = [];
                    this.CompanyQuestionList = res.data.leadsQuestionsVOList.filter(
                        (item) => (item.selectedOptions != null || item.leadsQuestions.type == 5)
                    );
                    this.CompanyQuestionList.map((item, index) => {
                        if (item.leadsQuestions.type == 9) {
                            item.leadsOptions = JSON.parse(item.selectedOptions)
                        }
                        item.selectedCodes = JSON.parse(item.selectedOptions);
                        if (index == 0) {
                            item.showCode = Number(item.selectedCodes.id);
                        }

                    });
                    this.getLeadsList()
                    this.getleadsPostFilter()


                }
            });
        },
        getleadsPostFilterchangeSearch(){
                        this.checked=false
            this.compareList=[]
            this.leadsPostFilterList=null
            this.$store.dispatch("app/setcollectList", []);
            this.$store.dispatch("app/setchangeList",  this.compareList);
            this.setToolsAcive();
            this.getleadsPostFilter()
        },
        // 获取leadsPostFilter
        getleadsPostFilter() {
            this.RiskLoding=true
            leadsPostFilter({
                leads: this.leadsList,
                leadsPostFilter: this.leadsPostFilterList,
                answersHeadId: this.labelsCode,
                page:1,
                pageSize:100,
           
                type:this.getSearchListType,
            }).then(res => {
                if (res.code == 200) {
             
                    res.data.leadsQuestionsVOList.map(item => {
                        if (item.selectedCodes != null) {

                            item.selectedCodes = [JSON.parse(item.selectedCodes).optionsCode]



                        } else {
                            item.selectedCodes = []
                        }
                    })
                    this.ComanyFilterList = res.data.leadsQuestionsVOList
                    let arr2 = []
                    this.ComanyFilterList.forEach((item, index) => {
                        if (item.selectedCodes != null && item.selectedCodes != undefined && item.selectedCodes.length > 0) {
                            arr2.push({
                                questionCode: item.leadsQuestions.code,
                                selected: item.selectedCodes,
                            });
                        }
                    })

                    this.getSearchList(arr2)
                }

            })
        },
        // 获取leadsList
        getLeadsList() {
            let arr1 = [];
            this.CompanyQuestionList.forEach((item) => {
                if (item.selectedCodes != null  ) {
                    if (Array.isArray(item.selectedCodes)) {
                        if (item.selectedOptions != '[]') {
                            arr1.push({
                                questionCode: item.leadsQuestions.code,
                                selected: item.selectedCodes.map((item) => {
                                    return item.optionsCode;
                                }),
                            });
                        }

                    } else {
                        if (item.leadsQuestions.type == 7) {
                            arr1.push({
                                questionCode: item.leadsQuestions.code,
                                selected: [item.selectedCodes],
                            });
                        } else {
                            arr1.push({
                                questionCode: item.leadsQuestions.code,
                                selected: [item.selectedCodes.optionsCode],
                            });
                        }

                    }
                }
            });
            this.leadsList = arr1
                                  this.leadsListModuleCode=arr1[1].selected[0]

        },
        // 获取列表数据
        getSearchList(leadsPostFilter) {
            this.RiskLoding=true
            // leadsPostFilterList
            findPartnerDetail({
                leads: this.leadsList,
                answersHeadId: this.labelsCode,
                     page:this.page.pageNo,
                pageSize:this.page.pageSize,
                type:this.getSearchListType,
                leadsPostFilter: leadsPostFilter,
                

            }).then((res) => {
                if (res.code == 200 && res.data != null) {
                    this.CompanyQuestionShow = false;
                    let parentTable = [];
                    let list = (parentTable = res.data.rows);
                    list = list.map((item, index) => {
                        let countryImg = this.getCountryImgUrl(item.company_country);
                        if (countryImg) {
                            let flag = require("../../../../static" + countryImg);
                            parentTable[index].flag = flag;
                            this.refresh++;
                        }
                    });

                    this.CompanyList = parentTable;
                    this.CompanyList.map((item) => {
                        item.NewstableData = [];
                        item.prifeTeable = {};
                        item.InsdustryTable = [];
                        item.companyIncomes = [];

                        item.chartInstance = null;
                    });
                    this.CompanyListRandom=parentTable
                    this.riskTotal=res.data.total
                    this.RiskLoding=false
                } else {
                           this.riskTotal=''
                    this.CompanyList = []
                    this.RiskLoding=false
                }
            });
        },
        // 删除元素
        DelClick(item, index) {
       
            if(this.PCMoudele[13].hasPrivilege){
                this.DelIndex = index;
            this.deledeLaeadsDialog = true;
            // this.CompanyList.map(item=>{
            //     item.isRotated=false
            // })
             
            // this.NationalIndustryShow = false
            // this.nationalCompetitivenessIndex=undefined
            }else{
                this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
            }
        },
        // 删除元素
        deLaeadsDialogubmit() {
            this.CompanyList=this.CompanyList.slice(0,20)
            this.CompanyList.splice(this.DelIndex, 1)
            this.compareList = this.CompanyList.filter((item) => item.isChecked);
            // this.compareList.splice(this.DelIndex, 1)

            
            if(this.compareList.length==0){
                this.compareList.map((item) => {
                        item.isChecked = false;
                    });
                 
                    
                    this.setToolsAcive();
                    this.$store.dispatch("app/setcollectList", []);
                    this.$store.dispatch("app/setchangeList",  this.compareList);
                    this.checked=false
            }else{
                this.$store.dispatch("app/setTools", {
                name: "compare",
                key: "isActive",
                value: this.compareList.length>0&&this.compareList.length<4,
            });
            }
            this.$store.dispatch("app/setchangeList",  this.compareList);
      
            this.CompanyList.map(item=>{
                item.isRotated=false
            })
             
            this.NationalIndustryShow = false
            this.NationalIndustryActive=undefined
            this.deledeLaeadsDialog = false;
        },
        // 取消钉
        CansoleClick(item, index) {
            item.isDing = false;
            let dingList = this.CompanyList.filter((item) => item.isDing == true);
            const removedItem = this.CompanyList.splice(index, 1)[0];
            this.CompanyList.splice(dingList.length, 0, removedItem);
            // findPartnerPcnotDing({
            //     aaaId: item.aaa_id,
            //     answersHeadId: this.labelsCode,

            // }).then((res) => {
            // });
        },
        // 钉
        DingClick(item, index) {
            if(this.PCMoudele[12].hasPrivilege){
              this.chageItTrue=true
                // if (this.labelsCode) {
                item.isDing = true;
                // item.isRotated=false
                this.CompanyList.map((ite)=>{
                    ite.isRotated=false
                })
                const removedItem = this.CompanyList.splice(index, 1)[0];
                this.NationalIndustryShow = false
                this.NationalIndustryActive=undefined
                // 将删除的数据插入到数组最开始的位置
                this.CompanyList.unshift(removedItem);
                // 保存钉
                // findPartnerPcding({
                //     aaaId: item.aaa_id,
                //     answersHeadId: this.labelsCode,
                // }).then((res) => {
                // });
            // } else {
            //     this.SaveMyAnswer()

            // }
            }else{
                this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
            }
         

        },
        // 移动
        onMove(e) {
            if (e.relatedContext.element.isDing == true) return false;
            return true;
        },
        // 点击列表出现右侧数据
        NationalIndustry(item, index) {
            this.chageItTrue=true
            if(this.PCMoudele[16].hasPrivilege){
          
            this.LastUpdate=item.update_year
                getCompanyIndustryInfo({
                aaaId: item.aaa_id,
                countryCode: item.company_country,
            }).then((Res) => {
                if (Res.code == 200) {
                    this.CompanyObj = Res.data;
                   
                    this.resizeFn()
                }else{
                    this.CompanyObj = null
                    this.resizeFn()
                }
            });

         
            this.NationalIndustryActive = index;
            
            if(this.NationalIndustryActive !=undefined){
                this.NationalIndustryShow = true
            }else{
                this.NationalIndustryShow = false
            }
            }else{
                this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
            }

        

        },
        // 全选操作
        changeItemChecked(value) {
            if (this.CompanyList.filter((item) => item.isChecked).length > 0) {
                this.checked = true
            } else {
                this.checked = false
            }

            let selectCompany = this.CompanyList.filter((item) => item.isChecked);
            this.$store.dispatch("app/setchangeList", selectCompany);
            this.compareList = selectCompany;
            // this.$nextTick(() => { });

            this.$store.dispatch("app/setTools", {
                name: "edit",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "collect",
                key: "isActive",
                value: selectCompany.length > 0 && this.SavyeLeadsSuo == false,
            });
            this.$store.dispatch("app/setTools", {
                name: "saved",
                key: "isActive",
                value: true && this.Compare == false,
            });

            this.$store.dispatch("app/setTools", {
                name: "compare",
                key: "isActive",
                value: this.compareList.length > 0&&this.compareList.length<4,
            });
            this.$store.dispatch("app/setTools", {
                name: "export",
                key: "isActive",
                value: selectCompany.length > 0,
            });

            this.$store.dispatch("app/setTools", {
                name: "update",
                key: "isActive",
                value: selectCompany.length > 0,
            });

            this.$store.dispatch("app/setTools", {
                name: "download",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "reportError",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "share",
                key: "isActive",
                value: selectCompany.length > 0,
            });
        },
        // 全选操作
        changeSlctAll(value) {
            this.CompanyList.slice(0,20).forEach((item) => {
                item.isChecked = value;
            });
            let selectCompany = this.CompanyList.slice(0,20).filter((item) => item.isChecked);
            this.compareList = selectCompany;
            this.$store.dispatch("app/setchangeList", selectCompany);
              this.$store.dispatch("app/setTools", {
            name: "riskScanning",
            key: "isActive",
          value:  selectCompany.length > 0 &&selectCompany.length<101,
          });
            this.$store.dispatch("app/setTools", {
                name: "collect",
                key: "isActive",
                value: selectCompany.length > 0 && this.SavyeLeadsSuo == false,
            });
               this.$store.dispatch("app/setTools", {
            name: "customPortfolio",
            key: "isActive",
      value:  false ,
          });
            this.$store.dispatch("app/setTools", {
                name: "saved",
                key: "isActive",
                value: true && this.Compare == false,
            });

            this.$store.dispatch("app/setTools", {
                name: "compare",
                key: "isActive",
                value: selectCompany.length > 0&&selectCompany.length<4,
            });
            this.$store.dispatch("app/setTools", {
                name: "export",
                key: "isActive",
                value: selectCompany.length > 0,
            });

            this.$store.dispatch("app/setTools", {
                name: "update",
                key: "isActive",
                value: selectCompany.length > 0,
            });

            this.$store.dispatch("app/setTools", {
                name: "download",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "reportError",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "share",
                key: "isActive",
                value: selectCompany.length > 0,
            });
               this.$store.dispatch("app/setchangeList",   selectCompany);
           sessionStorage.setItem('riskScanList',JSON.stringify(selectCompany))
        },
        cellClassName({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                return "highlight-cell"; // 设置你想要的背景色
            }
        },
        SavedcloseDialog(value) {
            this.SavyeLeadsSuo = value;
            this.Saved = undefined
            // this.$router.go(0);
        },
        ExportDialog(value) {
            this.ExportDialogSuo = value;
        },
        UpdateDialog(value) {
            this.UpdateDialogSuo = value;
        },


        // setTools
        setTools() {
            this.$store.dispatch("app/setTools", {
                name: "menu",
                key: "isActive",
                value: true,
            });

            this.$store.dispatch("app/setTools", {
                name: "select",
                key: "isActive",
                value: true,
            });

            this.$store.dispatch("app/setTools", {
                name: "edit",
                key: "isActive",
                value: false,
            });

            this.$store.dispatch("app/setTools", {
                name: "sort",
                key: "isActive",
                value: false,
            });
        }, // getDetail
        getDetail() {
            this.$router.push({
                path: "/index/risk/details/fgfdsg/riskdetails",
            });
        }, // setThemeColor
        setThemeColor() {
        
            this.$store.dispatch("app/setThemColor", "#8E86DD");
            this.$store.dispatch("app/setSearchType", "risk");
        },
        // srcviewscompanylistriskvueMethodEnd
    },
    computed: {},
    created() {
         this.setToolsAcive();
    },
    mounted() {
        //
        this.setThemeColor();
        this.setToolsfalse()
        if(this.token){
            window.addEventListener('resize', this.resizeFn)
       
     

     this.getHuokePartPrivilegeList()
    
        }
     

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeFn)
    },
};
</script>
<style scoped>
.ud6279 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-top: 7.642857142857143rem;
}

.u96d4d {
    width: 29rem;
}

.uba4wV3 {
    margin-right: 1.0714285714285714rem;
    margin-bottom: 0.7142857142857143rem;
    margin-top: 0.7142857142857143rem;
    margin-left: 1.0714285714285714rem;
}

.ub7918 {
    color: #999999;
    margin-bottom: 0.7142857142857143rem;
    font-size: 1.1428571428571428rem;
    text-align: left;
    font-style: normal;
   
    margin-bottom: 0.7142857142857143rem;
    overflow: hidden;
}

.uVwoZks {
    width: 100%;
}

.hidemenu {
    display: block;
    width: 0em;
    padding-left: 0em;
    padding-top: 0em;
    padding-bottom: 0em;
    padding-right: 0em;
    box-sizing: border-box;
    overflow-y: hidden;
    overflow-x: hidden;
}

.udb507 {
    width: calc(100% - 24rem);
    display: flex;
    height: 100%;
    box-sizing: border-box;
    padding: 0.7142857142857143rem;
    flex-direction: column;
    padding-left: 0rem;
    margin-left: 0.7142857142857143rem;
}

.scrollbar {
    overflow: hidden;
    /* overflow-y: auto; */
}

.udb507two {
    width: 100%;
}

.risk-right {
    width: 45%;
    padding: 1.4285714285714286rem;
    padding-top: 2.142857142857143rem;
    margin-left: 0.7285714285714286rem;
    background-color: #ffffff;
    overflow-y: scroll;
}

.risk-center-list {
    flex: 1;
    width: 49%;
    overflow-y: scroll;
}

.Upadetime {
    font-size: 1.2857142857142858rem;
    color: #666666;
    margin-right: 2.142857142857143rem;
}

.flex_center_between_box p {
    font-size: 1.7142857142857142rem;
    color: #1a2332;
    /* height: 2.142857142857143rem; */
    margin-bottom: 0.82205142857143rem;
    display: flex;
    align-items: flex-start;
}

.risk-right-content {
    padding: 1.4285714285714286rem 0rem;
    border-top: 0.07142857142857142rem solid #cccccc;
    /* border-bottom: 0.07142857142857142rem solid #CCCCCC; */
}

.risk-right-content-title {
    /* font-weight: 400; */
    font-size: 1.4285714285714286rem;
    color: #1a2332;
    height: 1.7142857142857142rem;
    margin-bottom: 1.4285714285714286rem;
    font-family: "DMSans Bold";
}

.right-txt {
    text-align: right;
    font-size: 1.2857142857142858rem;
    color: #1a2332;
    line-height: 1.8571428571428572rem;
}

.left-txt {
    font-size: 1.2857142857142858rem;
    color: #666666;
}

.margin16 {
    margin-top: 1.1428571428571428rem;
}

.highlight-cell {
    background-color: #f2f5f9 !important;
}

.risk-right .el-table .cell {
    color: #1a2332;
}

.table-content {
    height: 3.5714285714285716rem !important;
    line-height: 3.5714285714285716rem;
}

.risk-right .el-table th.el-table__cell {
    background-color: #f2f5f9 !important;
}

.conpany-center-list {
    padding: 1.4285714285714286rem;
    /* padding-bottom: 2.14285714rem; */
    background: #ffffff;
    box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem rgba(0, 0, 0, 0.12);
    border-radius: 0.2857142857142857rem;
    margin-bottom: 0.7142857142857143rem;
}

.conpany-center-list-left {
    font-size: 1.7142857142857142rem;
    color: #1a2332;
    display: flex;
    align-items: flex-start;
    /* width: 64%; */
    width: fit-content;
    max-width: 72%;
}

.conpany-center-list-right {}

.risk-center-list .el-checkbox__inner,
.Alchecked .el-checkbox__inner {
    height: 1.4285714285714286rem !important;
    width: 1.4285714285714286rem !important;
}

.conpany-center-list-left .el-checkbox__inner {
    margin-top: 0.2857142857142857rem !important;
}

.risk-center-list .el-checkbox__inner::after,
.Alchecked .el-checkbox__inner::after {
    height: 0.7142857142857143rem;
    left: 0.5rem;
}

.risk-center-list .el-checkbox__input.is-checked .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #8E86DD;
    border-color: #8E86DD;
}

.risk-center-list .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked .el-checkbox__inner:hover .risk-center-list .el-checkbox__inner:hover {
    border: 0.07142857142857142rem solid #dcdfe6;
}

.risk-center-list .el-checkbox__input.is-checked+.el-checkbox__label,
.Alchecked .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #1a2332;
}

.indexPositon {
    margin-right: 1.4285714285714286rem;
    color: #685ED1;
    width: 1.4285714285714286rem;
}

.indexPositonactive {
    margin-right: 1.4285714285714286rem;
    color: #999999;
    width: 1.4285714285714286rem;
    font-family: "DMSans Bold";
}

.list-text-color {
    font-size: 1.2857142857142858rem !important;
    color: #666666 !important;
    display: flex;
    align-items: center;
}

.list-text-color span {
    color: #1a2332 !important;
    margin-left: 0.7142857142857143rem;
}

.overexperise {
    max-width: 50%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: fit-content;
}

.list-text-color img {
    width: 2.5714285714285716rem;
    height: 1.8571428571428572rem;
    margin-right: 0.7142857142857143rem;
}

.margin20 {
    margin-left: 1.4285714285714286rem;
}

.iconbg {
    width: 3.5714285714285716rem;
    height: 3.5714285714285716rem;
    background: #eeeeee;
    border-radius: 50%;
    cursor: pointer;
}

.conpany-center-list-right p {
    justify-content: flex-end;
}

.bottom-list-echarts {
    padding-left: 2.8142857142857144rem;
    display: flex;
    justify-content: space-between;
}

.bottom-list-echarts-li {
    padding: 1.4285714285714286rem;
    background: #f5f5f5;
    height: 18.571428571428573rem;
    /* flex: 1; */
    width: 33%;
    padding-bottom: 0.7142857142857143rem;
}

.icontransform {
    display: inline-block;
    transition: transform 0.5s ease;
    /* 设置过渡效果 */
    cursor: pointer;
}

.rotate {
    transform: rotate(-180deg);
    /* 旋转180度 */
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active 在 Vue 2.x 中 */
    {
    opacity: 0;
    /* 初始透明度 */
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
    /* 淡入淡出动画 */
}

.iconbgActive {
    background-color: #8E86DD;
}

.left_menu_title {
    font-size: 1.7142857142857142rem;
    color: #1a2332;
    margin: 1.4285714285714286rem 0rem;
    padding-bottom: 10px;
    border-bottom: 1px solid #DDDDDD;
    font-family: "DMSans Bold";
}

.left_menu_question p {
    font-size: 1.1428571428571428rem;
    color: #1a2332;
    margin-bottom: 1.0714285714285714rem;
        font-family: "DMSans Bold";
}
.left_menu_question /deep/ .el-select .el-input__suffix{
    display: none;
}
.left_menu_question .el-input__inner {
    height: 2.5714285714285716rem;
    background: #ffffff;
    border-radius: 0.2857142857142857rem;
    border: 0.07142857142857142rem solid #cccccc;
    font-size: 1.1428571428571428rem;
    color: #1a2332;
    padding-left: 0.7142857142857143rem !important;
}

.left_menu_question /deep/ .el-select .el-input.is-focus .el-input__inner,
.left_menu_question /deep/ .el-select .el-input__inner:focus {
    border: 0.07142857142857142rem solid #cccccc !important;
    border-color: #8E86DD !important;
    line-height: 2.428571rem !important;
}

.left_menu_question {
    border-bottom: 0.07142857142857142rem solid #dddddd;
    margin-bottom: 0.7142857142857143rem;
    padding-bottom: 1.4285714285714286rem;
}
.FilterQuestion .left_menu_question{
       padding-bottom: 0rem;
}
/deep/ .el-input.is-disabled .el-input__inner {
    background-color: #f5f5f5;
    border-color: #cccccc;
    color: #999999;
    line-height: 2.428571rem !important;
}

.left_menu_bottom {
    font-size: 1.1428571428571428rem;
    color: #1a2332;
    margin-bottom: 3rem;
}

.Answerbutoon {
    font-size: 1.2857142857142858rem;
    color: #ffffff;
    text-align: center;
    background: #8E86DD;
    border-radius: 0.7142857142857143rem;
    height: 2.857142857142857rem;
    line-height: 2.857142857142857rem;
    cursor: pointer;
 
    width: 20.44285714rem;
}
.AnswerbutoonBox{
    position: fixed;
    bottom: 0px;
    z-index: 999;
    padding-bottom: 10px;
    background: rgb(245, 245, 245);
}
.bottom-list-echarts-li-left {
    border-right: 0.07142857142857142rem solid #dddddd;
    padding-right: 2.142857142857143rem;
    width: 50%;
}

.bottom-list-echarts-li-right {
    padding-left: 2.142857142857143rem;
    width: 50%;
}

.bottom-list-echarts-li-left-text {
    font-size: 1rem;
    color: #1a2332;
    height: 1.2857142857142858rem;
    margin-bottom: 1.1428571428571428rem;
    width: 100%;
}

.bottom-list-echarts-head {
    font-size: 1.286em !important;
    color: #1a2332;
    font-family: "DMSans bold";
}

.bottom-list-echarts-box {
    padding-top: 0.7142857142857143rem;
    margin-top: 0.7142857142857143rem;
    border-top: 0.07142857142857142rem solid #dddddd;
}

.news-text {
    font-size: 1em !important;
    color: #8E86DD !important;
    height: 1.2857142857142858rem;
    margin-bottom: 0.7142857142857143rem;
    width: 75%;
    /* 设置宽度 */
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏超出部分 */
    text-overflow: ellipsis;
    /* 使用省略号表示超出部分 */
}

.bottom-list-echarts-li ul {
    padding-top: 0.7142857142857143rem;
    border-top: 0.07142857142857142rem solid #dddddd;
    max-height: 73%;
    overflow: hidden;
    /* overflow: auto; */
}

.MoreCompany {
    font-size: 1rem;
    color: #8E86DD;
    line-height: 2.142857142857143rem;
    text-align: center;
    cursor: pointer;
}

.profit-txt {
    width: 75%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.color1290C9 {
    text-align: right;
}

.btn_exportyellow {
    width: 12.857142857142858rem;
    height: 2.857142857142857rem;
    background: #8E86DD;
    border-radius: 0.7142857142857143rem;
    font-size: 1.2857142857142858rem;
    color: #fff;
    /* line-height: 2.857142857142857rem; */
}

.btn_exportCollect {
    background: #8E86DD !important;
    color: #ffffff !important;
    border-radius: 0.7142857142857143rem
}

.question_bottom .btn_exportyellow {
    font-size: 1.1428571428571428rem;
    color: #fff;
}

.question-detail_cont-list h3 {
    margin-top: 0.7142857142857143rem;
    font-family: DMSans, DMSans;
    font-weight: 400;
    font-size: 1.2857142857142858rem;
    color: #1a2332;
    /* height: 1.7142857142857142rem; */
    /* line-height: 1.7142857142857142rem; */
}

.question_bottom {
    padding-top: 1.4285714285714286rem;
    display: flex;
    justify-content: space-between;
}

.SaveDialog_input {
    margin: 2.142857142857143rem 0rem;
}

.SaveDialog_input /deep/ .el-input__inner {
    height: 3.5714285714285716rem;
    background: #ffffff;
    border-radius: 0.5714285714285714rem;
    border: 0.07142857142857142rem solid #cccccc;
    font-size: 1.4285714285714286rem;
}

button:disabled {
    cursor: no-drop !important;
}

.el-popover {
    padding: 10px !important;
    min-width: auto;
}

/deep/ .el-button:hover {
    color: #FFFFFF !important
}

.uedbd2 {
    height: 100%;
}

.right_cont_box {
    height: 100%;
    overflow-y: auto;
}

.Country_img {
    height: 1.4rem;
    width: 2rem;
    margin-right: 0.8rem;
}

.Country_name {
    line-height: 1.6rem !important;
    font-size: 1.5rem;
}

.Search_Company {
    margin-bottom: 0.5rem;
    height: 3rem;
}

.yellow {
        font-family: "DMSans Bold";
    font-size: 1.14285714rem !important;
    color: #685ED1;
    margin-bottom: 5px;
    border-bottom: 2px solid #685ED1;
}
.yellownone{
    margin-bottom: 2px;
}
.flilterClass {
    font-size: 1.14285714rem !important;
    color: #1a2332;
}

.coll_child_name {
    width: 16.142857142857142rem;
}

.coll_child /deep/ .el-radio {
    color: #1a2332;
    line-height: 1;
    font-size: 1.333333rem !important;
    cursor: pointer;
    white-space: nowrap;
    outline: 0;
    margin-right: 0px !important;
    margin-bottom: 1.4285714285714286rem !important;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #8E86DD;
    background: #fff;
}

/deep/.el-radio__input.is-checked .el-radio__inner::after {
    background: #8E86DD;
}

/deep/.is-checked .el-checkbox__label .coll_child_name {
    /* color: #8E86DD; */
    color: #8E86DD !important;
}

/deep/ .left_menu .el-checkbox__inner {
    border-radius: 50%;
    font-size: 1.333333rem !important;
}

/deep/.left_menu .el-checkbox__input.is-checked .el-checkbox__inner {
    background: #fff !important;
    color: #8E86DD !important;
    border-color: #8E86DD !important;
}

/deep/.left_menu .el-checkbox__input.is-checked .el-checkbox__inner::after {
    background: #8E86DD !important;
}

/deep/.scrollbar .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #8E86DD !important;
    border-color: #8E86DD !important;
}

/deep/.scrollbar .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #8E86DD !important;
}


/* /deep/ .left_menu .el-checkbox__inner::after {

}*/
/deep/ .left_menu .el-checkbox__inner::after {
    left: 0.18285714285714285rem;
    width: 0.9rem;
    height: 0.9rem;
    border-radius: 50% !important;

}

.huanyipi {
    color: #685ED1;
    margin-right: 1.42857143rem;
    cursor: pointer;
}
.left_menu-headbox{
    width: 24rem;
    padding-left: 2.142857142857143rem;
    padding-right: 1.428571428571428rem;
    transition: 0.2s;
}

</style>